var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
var CLAIMS_MODULE_ASSETS_MAP = {};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(CLAIMS_MODULE_ASSETS_MAP);
};

// src/pages/claims-page/claims-summary-page.container.tsx
import * as React25 from "react";
import {
  SCREEN_NAMES as SCREEN_NAMES10,
  PRODUCT_AREA as PRODUCT_AREA10,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA10,
  usePageViewAnalytics as usePageViewAnalytics3
} from "@leagueplatform/analytics";
import { useIntl as useIntl13 } from "@leagueplatform/locales";
import { useDocumentTitle } from "@leagueplatform/web-common";

// src/pages/claims-page/claims-summary-page-static-filters.tsx
import React6, { useEffect } from "react";
import { Box, Responsive } from "@leagueplatform/genesis-core";
import { useSearchParams } from "@leagueplatform/web-common";
import {
  ClaimsSummaryLayout,
  ClaimsErrorState as ClaimsErrorState2,
  ClaimsSummarySidebar
} from "@leagueplatform/claims-ui";
import { useIntl as useIntl2 } from "@leagueplatform/locales";
import {
  useToggleClaimsFilter,
  useIsFirstLoad
} from "@leagueplatform/claims-common";

// src/components/claims-list-filters/claims-list-filter.container.tsx
import * as React from "react";
import {
  useAllowClearFilters,
  useClearFilters
} from "@leagueplatform/claims-common";

// src/claims.config.ts
import { useConfigProperty } from "@leagueplatform/core";
import {
  createDynamicClaimPropertyFilterFunction
} from "@leagueplatform/claims-common";
var featureFlags = {
  shouldShowClaimDetails: false,
  shouldShowDownloadClaims: false,
  shouldShowFilterChips: false
};
var defaultConfig = {
  featureFlags,
  filterableProperties: {
    patientName: {
      isVisible: (_, options) => options.length > 1,
      options: createDynamicClaimPropertyFilterFunction("patientName")
    },
    serviceDate: ["last_12_months", "year_to_date", "prior_year"],
    status: [
      "pending",
      "approved",
      "partially_paid",
      "not_covered",
      "adjusted"
    ],
    type: createDynamicClaimPropertyFilterFunction("type")
  },
  showClaimStatusDefinitions: true,
  showTotalCostOverviewAndAdditionalResources: true,
  showClaimsSummaryBackButton: true,
  enableDynamicFilters: false,
  enableTabFilters: false,
  getTotalCostOverviewVisibilityForClaim: () => true,
  showHealthInsuranceGlossary: false
};
var useClaimsConfig = () => useConfigProperty("claims", defaultConfig);

// src/hooks/use-feature-flag.hook.ts
function useFeatureFlag(flag) {
  var _a;
  const { featureFlags: featureFlags2 } = useClaimsConfig();
  return (_a = featureFlags2[flag]) != null ? _a : false;
}

// src/pages/claims-page/hooks/use-configured-filters.hook.ts
import {
  getConfiguredFilters
} from "@leagueplatform/claims-common";

// src/pages/claims-page/hooks/get-claims-query.hook.ts
import { useQuery } from "react-query";
import {
  getDeserializedClaimsSummary,
  GET_CLAIMS_SUMMARY_PATH
} from "@leagueplatform/claims-api";
import {
  useClaimsFilters,
  useSelectedDateRange,
  selectFilteredClaims,
  selectStartEndDates
} from "@leagueplatform/claims-common";
var STALE_TIME = 1e3 * 60 * 5;
function useGetClaimsSummaryQuery(variables, options) {
  return useQuery(
    [GET_CLAIMS_SUMMARY_PATH, variables],
    () => getDeserializedClaimsSummary(variables),
    __spreadValues({
      staleTime: STALE_TIME
    }, options)
  );
}
function useGetClaimsQuery(options) {
  const selectedDateRange = useSelectedDateRange();
  const { startDate, endDate } = selectStartEndDates(selectedDateRange);
  return useGetClaimsSummaryQuery(
    {
      queryParams: {
        "filter[startDate]": startDate,
        "filter[endDate]": endDate
      }
    },
    options
  );
}
function useGetFilteredClaimsQuery() {
  const filters = useClaimsFilters();
  return useGetClaimsQuery({
    select: ({ claims }) => selectFilteredClaims(claims, filters)
  });
}
function useGetRecentWidgetClaimsQuery() {
  const { startDate, endDate } = selectStartEndDates("90_days");
  const pageSize = 2;
  return useGetClaimsSummaryQuery(
    {
      queryParams: {
        "filter[startDate]": startDate,
        "filter[endDate]": endDate,
        "page[size]": pageSize
      }
    },
    {
      select: ({ claims }) => claims
    }
  );
}

// src/pages/claims-page/hooks/use-configured-filters.hook.ts
function useConfiguredFilters(filterableProperties) {
  return useGetClaimsQuery({
    keepPreviousData: true,
    select: ({ claims }) => {
      const configuredFilters = getConfiguredFilters(
        claims,
        filterableProperties
      );
      return configuredFilters;
    }
  });
}

// src/components/claims-list-filters/claims-list-filter.container.tsx
import {
  EVENT_NAME,
  PRODUCT_AREA,
  SCREEN_NAMES,
  SUB_PRODUCT_AREA,
  trackAnalyticsEvent
} from "@leagueplatform/analytics";
import { ClaimsListFilters } from "@leagueplatform/claims-ui";
function ClaimsListFiltersContainer() {
  const { filterableProperties } = useClaimsConfig();
  const { data: filters, isLoading } = useConfiguredFilters(filterableProperties);
  const clearFilters = useClearFilters();
  const allowClearFilters = useAllowClearFilters();
  const isFilterChipsEnabled = useFeatureFlag("shouldShowFilterChips");
  const handleClearFilters = React.useCallback(() => {
    clearFilters();
    trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA.CLAIMS,
      sub_product_area: SUB_PRODUCT_AREA.SUMMARY,
      screen_name: SCREEN_NAMES.FILTERS,
      detail: "clear all"
    });
  }, [clearFilters]);
  const handleFilterTypeClick = React.useCallback((filterType) => {
    trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA.CLAIMS,
      sub_product_area: SUB_PRODUCT_AREA.SUMMARY,
      screen_name: SCREEN_NAMES.FILTERS,
      detail: `selected filter type: ${filterType}`
    });
  }, []);
  const handleFilterChange = React.useCallback((isSelected, filterType) => {
    trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA.CLAIMS,
      sub_product_area: SUB_PRODUCT_AREA.SUMMARY,
      screen_name: SCREEN_NAMES.FILTERS,
      detail: isSelected ? `unselected filter option: ${filterType}` : `selected filter option: ${filterType}`
    });
  }, []);
  return /* @__PURE__ */ React.createElement(
    ClaimsListFilters,
    {
      filters: filters != null ? filters : [],
      isLoading,
      onClearFiltersClick: handleClearFilters,
      allowClearFilters,
      showFilterChips: isFilterChipsEnabled,
      onFilterTypeClick: handleFilterTypeClick,
      onFilterChange: handleFilterChange
    }
  );
}

// src/pages/claims-page/claims-summary-page-static-filters.tsx
import { LoadingIndicator as LoadingIndicator2 } from "@leagueplatform/web-common-components";
import { useConfigProperty as useConfigProperty2 } from "@leagueplatform/core";

// src/pages/claims-page/hooks/use-active-filter-count.hook.ts
import {
  useClaimsFilters as useClaimsFilters2,
  useSelectedDateRange as useSelectedDateRange2
} from "@leagueplatform/claims-common";
function useActiveFilterCount() {
  const filters = useClaimsFilters2();
  const selectedDateRange = useSelectedDateRange2();
  let filterCount = Object.values(filters).filter(Boolean).length;
  if (selectedDateRange) {
    filterCount += 1;
  }
  return filterCount;
}

// src/pages/claims-page/components/claims-card-list/claims-summary-card-list.container.tsx
import * as React2 from "react";
import {
  trackAnalyticsEvent as trackAnalyticsEvent2,
  EVENT_NAME as EVENT_NAME2,
  PRODUCT_AREA as PRODUCT_AREA2,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA2,
  SCREEN_NAMES as SCREEN_NAMES2
} from "@leagueplatform/analytics";
import {
  ClaimsErrorState,
  ClaimsSummaryCardList
} from "@leagueplatform/claims-ui";
import { useIntl } from "@leagueplatform/locales";
import { LoadingIndicator } from "@leagueplatform/web-common-components";
function ClaimsSummaryCardListContainer() {
  const { formatMessage } = useIntl();
  const {
    isError,
    isLoading,
    data: claims,
    error
  } = useGetFilteredClaimsQuery();
  const filterCount = useActiveFilterCount();
  const handleCardClick = React2.useCallback(() => {
    trackAnalyticsEvent2(EVENT_NAME2.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA2.CLAIMS,
      sub_product_area: SUB_PRODUCT_AREA2.SUMMARY,
      screen_name: SCREEN_NAMES2.SUMMARY,
      detail: "claim"
    });
  }, []);
  if (isLoading) {
    return /* @__PURE__ */ React2.createElement(LoadingIndicator, { inline: true });
  }
  if (isError || !claims) {
    return /* @__PURE__ */ React2.createElement(ClaimsErrorState, { error });
  }
  const isClaimsListEmpty = claims.length === 0;
  const isNoClaimsMatchFilters = isClaimsListEmpty && filterCount > 0;
  if (isNoClaimsMatchFilters) {
    return /* @__PURE__ */ React2.createElement(
      ClaimsErrorState,
      {
        heading: formatMessage({
          id: "CLAIMS_LIST_NO_CLAIMS_MATCH_FILTER_HEADING"
        }),
        message: formatMessage(
          {
            id: "CLAIMS_LIST_NO_CLAIMS_MATCH_FILTER_MESSAGE"
          },
          { filterCount }
        ),
        error: null
      }
    );
  }
  if (isClaimsListEmpty) {
    return /* @__PURE__ */ React2.createElement(
      ClaimsErrorState,
      {
        heading: formatMessage({ id: "CLAIMS_LIST_EMPTY_HEADING" }),
        message: formatMessage({ id: "CLAIMS_LIST_EMPTY_MESSAGE" }),
        error: null
      }
    );
  }
  return /* @__PURE__ */ React2.createElement(ClaimsSummaryCardList, { claims, onCardClick: handleCardClick });
}

// src/pages/claims-page/components/claims-helpful-links/claims-helpful-links.container.tsx
import * as React4 from "react";
import {
  EVENT_NAME as EVENT_NAME3,
  PRODUCT_AREA as PRODUCT_AREA3,
  SCREEN_NAMES as SCREEN_NAMES3,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA3,
  trackAnalyticsEvent as trackAnalyticsEvent3,
  usePageViewAnalytics
} from "@leagueplatform/analytics";

// src/pages/claims-page/hooks/use-download-claims-summary-query.hook.ts
import {
  GET_DOWNLOAD_CLAIMS_SUMMARY_PATH,
  getDownloadClaimsSummaryBlobAsFile
} from "@leagueplatform/claims-api";
import { useQuery as useQuery2 } from "react-query";
import { toastActions, TOAST_STATUS } from "@leagueplatform/toast-messages";
import {
  useSelectedDateRange as useSelectedDateRange3,
  selectStartEndDates as selectStartEndDates2
} from "@leagueplatform/claims-common";
function useDownloadClaimsSummaryQuery(claimType) {
  const selectedDateRange = useSelectedDateRange3();
  const { startDate, endDate } = selectStartEndDates2(selectedDateRange);
  return useQuery2(
    [GET_DOWNLOAD_CLAIMS_SUMMARY_PATH, { startDate, endDate }],
    () => getDownloadClaimsSummaryBlobAsFile(startDate, endDate, claimType),
    {
      enabled: false,
      retry: false,
      cacheTime: 0,
      onError() {
        toastActions.add({
          type: TOAST_STATUS.ERROR,
          textId: "PLAIN_SOMETHING_WENT_WRONG",
          contentId: "CLAIMS_SUMMARY_DOWNLOAD_ERROR"
        });
      }
    }
  );
}

// src/pages/claims-page/components/claims-helpful-links/claims-helpful-links.container.tsx
import { ClaimsHelpfulLinks } from "@leagueplatform/claims-ui";

// src/components/filters/hooks/use-selected-filters-store.hook.ts
import * as React3 from "react";
import { create } from "zustand";
import { useClearPagination } from "@leagueplatform/claims-common";
var useSelectedFilterStore = create((set) => ({
  defaultFilters: [],
  selectedFilters: [],
  selectedTab: void 0,
  setSelectedTab: (tabId) => set(() => ({
    selectedTab: tabId
  })),
  addSelectedFilter: (filterToAdd) => set((state) => ({
    selectedFilters: [filterToAdd, ...state.selectedFilters]
  })),
  populateDefaultFilters: (initialDefaultFilters) => set(() => ({
    selectedFilters: initialDefaultFilters,
    defaultFilters: initialDefaultFilters
  })),
  replaceFilterFromSameCategory: (newFilter, filterCategoryName) => set((state) => {
    const currentSelectedFilters = state.selectedFilters.filter(
      (selectedFilter) => selectedFilter.key !== filterCategoryName
    );
    return {
      selectedFilters: [newFilter, ...currentSelectedFilters]
    };
  }),
  replaceSelectedFiltersFromSameCategory: (newFilters, filterCategoryName) => set((state) => {
    const currentSelectedFilters = state.selectedFilters.filter(
      (selectedFilter) => selectedFilter.key !== filterCategoryName
    );
    return {
      selectedFilters: [...newFilters, ...currentSelectedFilters]
    };
  }),
  removeFilter: (filterToRemove) => set((state) => ({
    selectedFilters: state.selectedFilters.filter(
      (f) => f.key !== filterToRemove.key || f.value !== filterToRemove.value
    )
  })),
  clearFilterCategory: (filterCategoryName) => set((state) => ({
    selectedFilters: state.selectedFilters.filter(
      (filter) => filter.key !== filterCategoryName
    )
  })),
  clearAllFilters: () => set(() => ({
    selectedFilters: []
  })),
  resetFilterCategory: (filterCategoryName) => set((state) => {
    const filtersWithoutCurrentFilterCategory = state.selectedFilters.filter(
      (filter) => filter.key !== filterCategoryName
    );
    const defaultFilterOfCurrentFilterCategory = state.defaultFilters.find(
      (defaultFilter) => defaultFilter.key === filterCategoryName
    );
    if (defaultFilterOfCurrentFilterCategory) {
      return {
        selectedFilters: [
          defaultFilterOfCurrentFilterCategory,
          ...filtersWithoutCurrentFilterCategory
        ]
      };
    }
    return {
      selectedFilters: filtersWithoutCurrentFilterCategory
    };
  }),
  resetFilters: () => set((state) => ({
    selectedFilters: [...state.defaultFilters]
  }))
}));
var useSelectedFilters = () => {
  const selectedFilters = useSelectedFilterStore(
    (state) => state.selectedFilters
  );
  return selectedFilters;
};
var useDefaultFilters = () => {
  const defaultFilters = useSelectedFilterStore(
    (state) => state.defaultFilters
  );
  return defaultFilters;
};
var usePopulateDefaultFilters = () => {
  const populateDefaultFilters = useSelectedFilterStore(
    (state) => state.populateDefaultFilters
  );
  return React3.useCallback(
    (initialDefaultFilters) => {
      populateDefaultFilters(initialDefaultFilters);
    },
    [populateDefaultFilters]
  );
};
var useReplaceFilterFromSameCategory = () => {
  const replaceFilterFromSameCategory = useSelectedFilterStore(
    (state) => state.replaceFilterFromSameCategory
  );
  const clearPagination = useClearPagination();
  return React3.useCallback(
    (filterToAdd, filterCategoryName) => {
      clearPagination();
      replaceFilterFromSameCategory(filterToAdd, filterCategoryName);
    },
    [replaceFilterFromSameCategory, clearPagination]
  );
};
var useReplaceSelectedFiltersFromSameCategory = () => {
  const replaceSelectedFiltersFromSameCategory = useSelectedFilterStore(
    (state) => state.replaceSelectedFiltersFromSameCategory
  );
  const clearPagination = useClearPagination();
  return React3.useCallback(
    (filtersToAdd, filterCategoryName) => {
      clearPagination();
      replaceSelectedFiltersFromSameCategory(filtersToAdd, filterCategoryName);
    },
    [replaceSelectedFiltersFromSameCategory, clearPagination]
  );
};
var useRemoveSelectedFilter = () => {
  const removeSelectedFilter = useSelectedFilterStore(
    (state) => state.removeFilter
  );
  const clearPagination = useClearPagination();
  return React3.useCallback(
    (filterToRemove) => {
      clearPagination();
      removeSelectedFilter(filterToRemove);
    },
    [removeSelectedFilter, clearPagination]
  );
};
var useClearAllFilters = () => {
  const clearAllFilters = useSelectedFilterStore(
    (state) => state.clearAllFilters
  );
  const clearPagination = useClearPagination();
  return React3.useCallback(() => {
    clearPagination();
    clearAllFilters();
  }, [clearAllFilters, clearPagination]);
};
var useResetFilterCategory = () => {
  const resetFilterCategory = useSelectedFilterStore(
    (state) => state.resetFilterCategory
  );
  const clearPagination = useClearPagination();
  return React3.useCallback(
    (filterCategoryName) => {
      clearPagination();
      resetFilterCategory(filterCategoryName);
    },
    [resetFilterCategory, clearPagination]
  );
};
var useSelectedTabState = (defaultValue) => useSelectedFilterStore(
  (state) => {
    var _a;
    return [(_a = state.selectedTab) != null ? _a : defaultValue, state.setSelectedTab];
  }
);
var useResetFilters = () => {
  const resetFilters = useSelectedFilterStore((state) => state.resetFilters);
  const clearPagination = useClearPagination();
  return React3.useCallback(() => {
    clearPagination();
    resetFilters();
  }, [clearPagination, resetFilters]);
};

// src/pages/claims-page/components/claims-helpful-links/claims-helpful-links.container.tsx
function ClaimsHelpfulLinksContainer() {
  usePageViewAnalytics({
    product_area: PRODUCT_AREA3.CLAIMS,
    sub_product_area: SUB_PRODUCT_AREA3.SUMMARY,
    screen_name: SCREEN_NAMES3.HELPFUL_LINKS
  });
  const {
    showClaimStatusDefinitions,
    filterableProperties,
    showHealthInsuranceGlossary,
    healthInsuranceGlossaryLink
  } = useClaimsConfig();
  const shouldShowDownloadClaims = useFeatureFlag("shouldShowDownloadClaims");
  const [selectedTab] = useSelectedTabState();
  const { refetch: downloadClaimsSummary, isFetching: isDownloadingClaims } = useDownloadClaimsSummaryQuery(selectedTab);
  const handleDownloadClaimsClick = React4.useCallback(() => {
    downloadClaimsSummary();
    trackAnalyticsEvent3(EVENT_NAME3.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA3.CLAIMS,
      sub_product_area: SUB_PRODUCT_AREA3.SUMMARY,
      screen_name: SCREEN_NAMES3.HELPFUL_LINKS,
      detail: "download claims"
    });
  }, [downloadClaimsSummary]);
  const handleHowClaimsWorkToggle = React4.useCallback(
    (showHowClaimsWork) => {
      trackAnalyticsEvent3(EVENT_NAME3.BUTTON_CLICKED, {
        product_area: PRODUCT_AREA3.CLAIMS,
        sub_product_area: SUB_PRODUCT_AREA3.SUMMARY,
        screen_name: SCREEN_NAMES3.HELPFUL_LINKS,
        detail: showHowClaimsWork ? "close" : "how claims work"
      });
    },
    []
  );
  const handleHealthInsuranceGlossary = React4.useCallback(() => {
    trackAnalyticsEvent3(EVENT_NAME3.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA3.CLAIMS,
      sub_product_area: SUB_PRODUCT_AREA3.SUMMARY,
      screen_name: SCREEN_NAMES3.HELPFUL_LINKS,
      detail: "health insurance glossary"
    });
  }, []);
  const handleStatusDefinitionsToggle = React4.useCallback(
    (showDefinitions) => {
      trackAnalyticsEvent3(EVENT_NAME3.BUTTON_CLICKED, {
        product_area: PRODUCT_AREA3.CLAIMS,
        sub_product_area: SUB_PRODUCT_AREA3.SUMMARY,
        screen_name: SCREEN_NAMES3.HELPFUL_LINKS,
        detail: showDefinitions ? "close" : "claims status definitions"
      });
    },
    []
  );
  return /* @__PURE__ */ React4.createElement(
    ClaimsHelpfulLinks,
    {
      showClaimStatusDefinitions: !!showClaimStatusDefinitions,
      showDownloadClaims: shouldShowDownloadClaims,
      claimStatuses: filterableProperties.status,
      onDownloadClaimsClick: handleDownloadClaimsClick,
      isDownloadingClaims,
      onHowClaimsWorkToggle: handleHowClaimsWorkToggle,
      onStatusDefinitionsToggle: handleStatusDefinitionsToggle,
      showHealthInsuranceGlossary,
      onHealthInsuranceGlossaryClick: handleHealthInsuranceGlossary,
      healthInsuranceGlossaryLink
    }
  );
}

// src/pages/claims-page/components/claims-summary-sidebar-mobile/claims-summary-sidebar-mobile.container.tsx
import * as React5 from "react";
import {
  EVENT_NAME as EVENT_NAME4,
  PRODUCT_AREA as PRODUCT_AREA4,
  SCREEN_NAMES as SCREEN_NAMES4,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA4,
  trackAnalyticsEvent as trackAnalyticsEvent4,
  usePageViewAnalytics as usePageViewAnalytics2
} from "@leagueplatform/analytics";
import {
  ClaimsSummarySidebarMobile
} from "@leagueplatform/claims-ui";
function ClaimsSummarySidebarMobileContainer({
  renderHelpfulLinks
}) {
  usePageViewAnalytics2({
    product_area: PRODUCT_AREA4.CLAIMS,
    sub_product_area: SUB_PRODUCT_AREA4.SUMMARY,
    screen_name: SCREEN_NAMES4.HELPFUL_LINKS
  });
  const handleModalClose = React5.useCallback(() => {
    trackAnalyticsEvent4(EVENT_NAME4.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA4.CLAIMS,
      sub_product_area: SUB_PRODUCT_AREA4.SUMMARY,
      screen_name: SCREEN_NAMES4.HELPFUL_LINKS,
      detail: "close"
    });
  }, []);
  const handleHelpfulLinksClick = React5.useCallback(() => {
    trackAnalyticsEvent4(EVENT_NAME4.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA4.CLAIMS,
      sub_product_area: SUB_PRODUCT_AREA4.SUMMARY,
      screen_name: SCREEN_NAMES4.SUMMARY,
      detail: "helpful links"
    });
  }, []);
  return /* @__PURE__ */ React5.createElement(
    ClaimsSummarySidebarMobile,
    {
      renderHelpfulLinks,
      onModalClose: handleModalClose,
      onHelpfulLinksClick: handleHelpfulLinksClick
    }
  );
}

// src/pages/claims-page/claims-summary-page-static-filters.tsx
function ClaimsSummaryPageStaticFilters() {
  const searchParams = useSearchParams();
  const searchParam = searchParams.get("type");
  const searchParamType = searchParam;
  const toggleFilter = useToggleClaimsFilter();
  const { formatMessage } = useIntl2();
  const isFirstLoad = useIsFirstLoad();
  useEffect(() => {
    if (searchParamType) {
      toggleFilter({ type: searchParamType });
    }
  }, [toggleFilter, searchParamType]);
  const { isError, isLoading, data, error } = useGetFilteredClaimsQuery();
  const filterCount = useActiveFilterCount();
  const isClaimsListEmpty = (data == null ? void 0 : data.length) === 0 && filterCount === 0;
  const pageHeaderConfig = useConfigProperty2("core.ui.components.pageHeader");
  const isSwoop = (pageHeaderConfig == null ? void 0 : pageHeaderConfig.shape) === "swoop";
  const { showClaimsSummaryBackButton, slots } = useClaimsConfig();
  const Banner = slots == null ? void 0 : slots.Banner;
  if (isLoading && isFirstLoad) {
    return /* @__PURE__ */ React6.createElement(
      ClaimsSummaryLayout,
      {
        isSwoop,
        showBackButton: showClaimsSummaryBackButton,
        banner: Banner ? /* @__PURE__ */ React6.createElement(Banner, null) : null
      },
      /* @__PURE__ */ React6.createElement(LoadingIndicator2, null)
    );
  }
  if (isError) {
    return /* @__PURE__ */ React6.createElement(
      ClaimsSummaryLayout,
      {
        isSwoop,
        showBackButton: showClaimsSummaryBackButton,
        banner: Banner ? /* @__PURE__ */ React6.createElement(Banner, null) : null
      },
      /* @__PURE__ */ React6.createElement(ClaimsErrorState2, { error })
    );
  }
  if (isClaimsListEmpty) {
    return /* @__PURE__ */ React6.createElement(
      ClaimsSummaryLayout,
      {
        isSwoop,
        showBackButton: showClaimsSummaryBackButton,
        banner: Banner ? /* @__PURE__ */ React6.createElement(Banner, null) : null
      },
      /* @__PURE__ */ React6.createElement(
        ClaimsErrorState2,
        {
          heading: formatMessage({ id: "CLAIMS_LIST_EMPTY_HEADING" }),
          message: formatMessage({ id: "CLAIMS_LIST_EMPTY_MESSAGE" }),
          error: null
        }
      )
    );
  }
  return /* @__PURE__ */ React6.createElement(
    ClaimsSummaryLayout,
    {
      isSwoop,
      showBackButton: showClaimsSummaryBackButton,
      banner: Banner ? /* @__PURE__ */ React6.createElement(Banner, null) : null
    },
    !isFirstLoad && /* @__PURE__ */ React6.createElement(Responsive, { down: "mobileLandscape" }, /* @__PURE__ */ React6.createElement(
      ClaimsSummarySidebarMobileContainer,
      {
        renderHelpfulLinks: /* @__PURE__ */ React6.createElement(ClaimsHelpfulLinksContainer, null)
      }
    )),
    !isFirstLoad && /* @__PURE__ */ React6.createElement(ClaimsListFiltersContainer, null),
    /* @__PURE__ */ React6.createElement(
      Box,
      {
        css: {
          display: "grid",
          gap: "$oneAndHalf",
          gridTemplateColumns: "4fr 1fr",
          "@mobile": {
            gridTemplateColumns: "1fr"
          },
          position: "relative"
        }
      },
      /* @__PURE__ */ React6.createElement(ClaimsSummaryCardListContainer, null),
      !isFirstLoad && /* @__PURE__ */ React6.createElement(Responsive, { up: "mobileLandscape" }, /* @__PURE__ */ React6.createElement(ClaimsSummarySidebar, null, /* @__PURE__ */ React6.createElement(ClaimsHelpfulLinksContainer, null)))
    )
  );
}

// src/pages/claims-page/claims-summary-page-dynamic-filters.tsx
import * as React13 from "react";
import {
  Box as Box3,
  Responsive as Responsive2,
  StackLayout as StackLayout2,
  VisuallyHidden as VisuallyHidden2,
  HeadingText
} from "@leagueplatform/genesis-core";
import { Pagination } from "@leagueplatform/genesis-core-alpha";
import {
  ClaimsErrorState as ClaimsErrorState4,
  ClaimsSkeletonLoaderList as ClaimsSkeletonLoaderList2,
  ClaimsSummaryLayout as ClaimsSummaryLayout2,
  ClaimsSummarySidebar as ClaimsSummarySidebar2
} from "@leagueplatform/claims-ui";
import {
  useClearAllFilters as useClearAllFilters3,
  usePagination,
  useSearchClaimsQueryAttributes,
  useSelectedFilters as useSelectedFilters6
} from "@leagueplatform/claims-common";
import { useIntl as useIntl6 } from "@leagueplatform/locales";
import {
  LoadingIndicator as LoadingIndicator3,
  PaginationContainer
} from "@leagueplatform/web-common-components";
import { useConfigProperty as useConfigProperty3 } from "@leagueplatform/core";
import {
  EVENT_NAME as EVENT_NAME8,
  PRODUCT_AREA as PRODUCT_AREA8,
  SCREEN_NAMES as SCREEN_NAMES8,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA8,
  trackAnalyticsEvent as trackAnalyticsEvent8
} from "@leagueplatform/analytics";

// src/pages/claims-page/components/claims-card-list/claims-card-list.component.tsx
import * as React7 from "react";
import {
  trackAnalyticsEvent as trackAnalyticsEvent5,
  EVENT_NAME as EVENT_NAME5,
  PRODUCT_AREA as PRODUCT_AREA5,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA5,
  SCREEN_NAMES as SCREEN_NAMES5
} from "@leagueplatform/analytics";
import {
  ClaimsCardList as ClaimsCardListUi,
  ClaimsErrorState as ClaimsErrorState3,
  ClaimsSkeletonLoaderList
} from "@leagueplatform/claims-ui";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
function ClaimsCardList({
  isLoading,
  claims
}) {
  const { formatMessage } = useIntl3();
  const handleCardClick = React7.useCallback(() => {
    trackAnalyticsEvent5(EVENT_NAME5.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA5.CLAIMS,
      sub_product_area: SUB_PRODUCT_AREA5.SUMMARY,
      screen_name: SCREEN_NAMES5.SUMMARY,
      detail: "claim"
    });
  }, []);
  if (isLoading) {
    return /* @__PURE__ */ React7.createElement(ClaimsSkeletonLoaderList, null);
  }
  const isClaimsListEmpty = claims.length === 0;
  if (isClaimsListEmpty) {
    return /* @__PURE__ */ React7.createElement(
      ClaimsErrorState3,
      {
        heading: formatMessage({ id: "CLAIMS_LIST_EMPTY_HEADING" }),
        message: formatMessage({ id: "CLAIMS_LIST_EMPTY_MESSAGE" }),
        error: null
      }
    );
  }
  return /* @__PURE__ */ React7.createElement(ClaimsCardListUi, { claims, onCardClick: handleCardClick });
}

// src/pages/claims-page/hooks/use-post-claims-search-query.hook.ts
import { useQuery as useQuery3 } from "react-query";
import {
  postDeserializedClaimsSearch,
  POST_CLAIMS_SEARCH_PATH
} from "@leagueplatform/claims-api";
var DEFAULT_VARIABLES = {
  body: {
    data: {
      id: "",
      type: "claims-search",
      attributes: { filters: [] }
    }
  }
};
function usePostClaimsSearchQuery(attributes, options) {
  const variables = __spreadValues({}, DEFAULT_VARIABLES);
  if (attributes) {
    variables.body.data.attributes = attributes;
  }
  return useQuery3(
    [POST_CLAIMS_SEARCH_PATH, variables],
    () => postDeserializedClaimsSearch(variables),
    __spreadValues({ staleTime: Infinity }, options)
  );
}

// src/pages/claims-page/components/claims-filters/claims-filters.component.tsx
import * as React11 from "react";
import {
  FilterDropdown,
  getFilterInputComponent
} from "@leagueplatform/claims-ui";
import {
  Box as Box2,
  SkeletonRectangle,
  StackLayout,
  UtilityText,
  VisuallyHidden
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl4 } from "@leagueplatform/locales";
import {
  trackAnalyticsEvent as trackAnalyticsEvent6,
  EVENT_NAME as EVENT_NAME6,
  PRODUCT_AREA as PRODUCT_AREA6,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA6,
  SCREEN_NAMES as SCREEN_NAMES6
} from "@leagueplatform/analytics";

// src/pages/claims-page/hooks/use-claims-filters-query.hook.ts
import { useQuery as useQuery4 } from "react-query";
import {
  GET_CLAIMS_FILTERS_PATH,
  getDeserializedClaimsFilters
} from "@leagueplatform/claims-api";
var DEFAULT_STALE_TIME = -1;
function useClaimsFiltersQuery(options) {
  return useQuery4(
    [GET_CLAIMS_FILTERS_PATH],
    () => getDeserializedClaimsFilters(),
    __spreadValues({ staleTime: DEFAULT_STALE_TIME }, options)
  );
}

// src/pages/claims-page/components/claims-filters/hooks/use-filter-input.hook.ts
import * as React10 from "react";
import { useSelectedFilters as useSelectedFilters4 } from "@leagueplatform/claims-common";

// src/pages/claims-page/components/claims-filters/hooks/use-single-select-filter.hook.ts
import * as React8 from "react";
import {
  useAddSelectedFilter,
  useRemoveSelectedFilter as useRemoveSelectedFilter2,
  useSelectedFilters as useSelectedFilters2
} from "@leagueplatform/claims-common";
function useSingleSelectFilter() {
  const selectedFilters = useSelectedFilters2();
  const addSelectedFilter = useAddSelectedFilter();
  const removeFilter = useRemoveSelectedFilter2();
  return React8.useCallback(
    (filter) => {
      const filterWithKey = selectedFilters.find((f) => f.key === filter.key);
      if (filterWithKey) {
        removeFilter(filterWithKey);
      }
      addSelectedFilter(filter);
    },
    [addSelectedFilter, removeFilter, selectedFilters]
  );
}

// src/pages/claims-page/components/claims-filters/hooks/use-multi-select-filter.hook.ts
import * as React9 from "react";
import {
  useAddSelectedFilter as useAddSelectedFilter2,
  useRemoveSelectedFilter as useRemoveSelectedFilter3,
  useSelectedFilters as useSelectedFilters3
} from "@leagueplatform/claims-common";
function useMultiSelectFilter() {
  const selectedFilters = useSelectedFilters3();
  const addSelectedFilter = useAddSelectedFilter2();
  const removeFilter = useRemoveSelectedFilter3();
  return React9.useCallback(
    (formattedFilters, filterKey) => {
      const allFiltersInKey = selectedFilters.filter(
        (f) => f.key === filterKey
      );
      const isRemoveFilterAction = allFiltersInKey.length > formattedFilters.length;
      if (isRemoveFilterAction) {
        const smallerSet = new Set(formattedFilters.map((obj) => obj.value));
        const removedFilter = allFiltersInKey.find(
          (filter) => !smallerSet.has(filter.value)
        );
        if (!removedFilter) {
          return;
        }
        removeFilter(removedFilter);
        return;
      }
      const newFilter = formattedFilters.filter((filter) => {
        const isNotNewFilter = allFiltersInKey.map((f) => f.value).includes(filter.value);
        if (isNotNewFilter)
          return false;
        return true;
      }).find((_, index) => index === 0);
      if (!newFilter) {
        return;
      }
      addSelectedFilter(newFilter);
    },
    [addSelectedFilter, removeFilter, selectedFilters]
  );
}

// src/pages/claims-page/components/claims-filters/utils/format-filter-value.util.ts
var formatFilterValue = (inputValue, filterKey, inputName) => inputValue.map((value) => ({ key: filterKey, value, label: inputName }));

// src/pages/claims-page/components/claims-filters/hooks/use-filter-input.hook.ts
function useFilterInput() {
  const selectedFilters = useSelectedFilters4();
  const handleSingleSelectFilter = useSingleSelectFilter();
  const handleMultiSelectFilter = useMultiSelectFilter();
  const handleFilterClick = React10.useCallback(
    (inputValue, filterKey, inputName) => {
      if (Array.isArray(inputValue)) {
        handleMultiSelectFilter(
          formatFilterValue(inputValue, filterKey, inputName),
          filterKey
        );
        return;
      }
      handleSingleSelectFilter({
        key: filterKey,
        value: inputValue,
        label: inputName
      });
    },
    [handleMultiSelectFilter, handleSingleSelectFilter]
  );
  return React10.useCallback(
    (value, key) => {
      var _a;
      const options = (_a = value.options) == null ? void 0 : _a.map(
        (option) => __spreadProps(__spreadValues({}, option), { id: option.value })
      );
      const filtersByKey = selectedFilters.filter((f) => f.key === key);
      const filterValue = filtersByKey.map((filter) => filter.value);
      return {
        filterValue,
        onClick: handleFilterClick,
        options,
        selectedFiltersLength: filtersByKey.length
      };
    },
    [handleFilterClick, selectedFilters]
  );
}

// src/pages/claims-page/components/claims-filters/claims-filters.component.tsx
var FILTER_BY_TEXT_ID = "filter-by-id";
function ClaimsFilters() {
  const {
    isLoading,
    isError,
    data: filters
  } = useClaimsFiltersQuery({ select: (res) => res.data });
  const getFilterInputProps = useFilterInput();
  const { formatMessage } = useIntl4();
  const handleFilterDropdownClick = React11.useCallback((filterType) => {
    trackAnalyticsEvent6(EVENT_NAME6.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA6.CLAIMS,
      sub_product_area: SUB_PRODUCT_AREA6.SUMMARY,
      screen_name: SCREEN_NAMES6.FILTERS,
      detail: `selected filter type: ${filterType}`
    });
  }, []);
  const handleFilterChange = React11.useCallback(
    (isSelected, filterType) => {
      trackAnalyticsEvent6(EVENT_NAME6.BUTTON_CLICKED, {
        product_area: PRODUCT_AREA6.CLAIMS,
        sub_product_area: SUB_PRODUCT_AREA6.SUMMARY,
        screen_name: SCREEN_NAMES6.FILTERS,
        detail: isSelected ? `selected filter option: ${filterType}` : `unselected filter option: ${filterType}`
      });
    },
    []
  );
  if (isLoading) {
    return /* @__PURE__ */ React11.createElement(Box2, null, /* @__PURE__ */ React11.createElement(SkeletonRectangle, { height: "calc($twoAndHalf * 2)" }), /* @__PURE__ */ React11.createElement(VisuallyHidden, null, formatMessage({ id: "LOADING" })));
  }
  if (isError || !(filters == null ? void 0 : filters.length)) {
    return null;
  }
  return /* @__PURE__ */ React11.createElement(StackLayout, { spacing: "$threeQuarters" }, /* @__PURE__ */ React11.createElement(UtilityText, { id: FILTER_BY_TEXT_ID, size: "eyebrow" }, formatMessage({ id: "FILTER_BY" })), /* @__PURE__ */ React11.createElement(
    StackLayout,
    {
      orientation: "horizontal",
      spacing: "$half",
      css: {
        overflowX: "auto",
        maxWidth: "100%",
        paddingBlockEnd: "$half"
      }
    },
    filters.map(({ value, label, key }) => {
      const {
        filterValue,
        onClick: handleFilterClick,
        options,
        selectedFiltersLength
      } = getFilterInputProps(value, key);
      const FilterInput = getFilterInputComponent(value.type);
      const isFilterHidden = FilterInput === null || (options == null ? void 0 : options.length) === 0;
      const dropdownLabel = selectedFiltersLength ? `${label} (${selectedFiltersLength})` : label;
      if (isFilterHidden) {
        return null;
      }
      return /* @__PURE__ */ React11.createElement(
        FilterDropdown,
        {
          label: dropdownLabel,
          key,
          labelById: FILTER_BY_TEXT_ID,
          onClick: () => {
            handleFilterDropdownClick(key);
          }
        },
        /* @__PURE__ */ React11.createElement(
          FilterInput,
          {
            onSubmit: (inputValue, inputName) => {
              handleFilterClick(inputValue, key, inputName);
              handleFilterChange(!!inputValue.length, key);
            },
            options,
            label,
            name: key,
            value: filterValue
          }
        )
      );
    })
  ));
}

// src/pages/claims-page/components/claims-selected-filters/claims-selected-filters.component.tsx
import {
  trackAnalyticsEvent as trackAnalyticsEvent7,
  EVENT_NAME as EVENT_NAME7,
  PRODUCT_AREA as PRODUCT_AREA7,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA7,
  SCREEN_NAMES as SCREEN_NAMES7
} from "@leagueplatform/analytics";
import {
  useClearAllFilters as useClearAllFilters2,
  useRemoveSelectedFilter as useRemoveSelectedFilter4,
  useSelectedFilters as useSelectedFilters5
} from "@leagueplatform/claims-common";
import { FilterChip, FilterChipsLayout } from "@leagueplatform/claims-ui";
import { TextAction } from "@leagueplatform/genesis-core";
import { useIntl as useIntl5 } from "@leagueplatform/locales";
import * as React12 from "react";
function ClaimsSelectedFilters({
  onClearAllFiltersClick: handleClearAllFiltersClick
}) {
  const { formatMessage } = useIntl5();
  const selectedFilters = useSelectedFilters5();
  const removeFilter = useRemoveSelectedFilter4();
  const clearFilters = useClearAllFilters2();
  const handleFilterChange = React12.useCallback(
    (filter) => {
      removeFilter(filter);
      trackAnalyticsEvent7(EVENT_NAME7.BUTTON_CLICKED, {
        product_area: PRODUCT_AREA7.CLAIMS,
        sub_product_area: SUB_PRODUCT_AREA7.SUMMARY,
        screen_name: SCREEN_NAMES7.FILTERS,
        detail: `unselected filter option: ${filter.key}`
      });
    },
    [removeFilter]
  );
  const handleClearAllFilters = React12.useCallback(() => {
    clearFilters();
    trackAnalyticsEvent7(EVENT_NAME7.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA7.CLAIMS,
      sub_product_area: SUB_PRODUCT_AREA7.SUMMARY,
      screen_name: SCREEN_NAMES7.FILTERS,
      detail: "clear all"
    });
    if (handleClearAllFiltersClick) {
      handleClearAllFiltersClick();
    }
  }, [clearFilters, handleClearAllFiltersClick]);
  if (!selectedFilters || !selectedFilters.length) {
    return null;
  }
  return /* @__PURE__ */ React12.createElement(FilterChipsLayout, null, selectedFilters.map((filter) => /* @__PURE__ */ React12.createElement(
    FilterChip,
    {
      key: `filterchip-${filter.key}-${filter.value}`,
      label: filter.label,
      onClick: () => {
        handleFilterChange(filter);
      }
    }
  )), /* @__PURE__ */ React12.createElement(
    TextAction,
    {
      as: "button",
      size: "medium",
      onClick: handleClearAllFilters,
      css: {
        whiteSpace: "nowrap"
      }
    },
    formatMessage({ id: "CLEAR_ALL" })
  ));
}

// src/pages/claims-page/claims-summary-page-dynamic-filters.tsx
var CLAIMS_LIST_HEADING_ID = "claims-list-heading-id";
function ClaimsSummaryPageDynamicFilters() {
  var _a;
  const { formatMessage } = useIntl6();
  const [isFirstRender, setIsFirstRender] = React13.useState(true);
  const clearSelectedFilters = useClearAllFilters3();
  const selectedFilters = useSelectedFilters6();
  const {
    clearPagination,
    currentPage,
    initialized,
    initializePagination,
    isNextButtonEnabled,
    isPrevButtonEnabled,
    onPageChange,
    pageSize,
    totalPages
  } = usePagination();
  const attributes = useSearchClaimsQueryAttributes(selectedFilters);
  const {
    data: { data: claims, meta } = { data: [] },
    isError,
    isLoading,
    error
  } = usePostClaimsSearchQuery(attributes, {});
  const containerRef = React13.useRef(null);
  const handleClaimsLoadedSuccess = React13.useCallback(() => {
    var _a2;
    if (!initialized)
      return;
    trackAnalyticsEvent8(EVENT_NAME8.SCREEN_LOADED, {
      detail: "new claims added",
      product_area: PRODUCT_AREA8.CLAIMS,
      sub_product_area: SUB_PRODUCT_AREA8.SUMMARY,
      screen_name: SCREEN_NAMES8.SUMMARY,
      current_page: currentPage,
      total_pages: totalPages,
      paginate_type: (_a2 = meta == null ? void 0 : meta.pagination) == null ? void 0 : _a2.strategy
    });
  }, [currentPage, initialized, (_a = meta == null ? void 0 : meta.pagination) == null ? void 0 : _a.strategy, totalPages]);
  React13.useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false);
    }
    if (meta == null ? void 0 : meta.pagination) {
      initializePagination(meta.pagination);
      handleClaimsLoadedSuccess();
    }
  }, [
    isFirstRender,
    initializePagination,
    meta == null ? void 0 : meta.pagination,
    handleClaimsLoadedSuccess
  ]);
  const handlePaginationPageChange = React13.useCallback(
    (newPage) => {
      if (onPageChange) {
        onPageChange(newPage);
        trackAnalyticsEvent8(EVENT_NAME8.BUTTON_CLICKED, {
          product_area: PRODUCT_AREA8.CLAIMS,
          sub_product_area: SUB_PRODUCT_AREA8.SUMMARY,
          screen_name: SCREEN_NAMES8.SUMMARY,
          current_page: newPage.pageNumber,
          total_pages: totalPages,
          paginate_type: newPage.buttonType
        });
      }
    },
    [onPageChange, totalPages]
  );
  const pageHeaderConfig = useConfigProperty3("core.ui.components.pageHeader");
  const isSwoop = (pageHeaderConfig == null ? void 0 : pageHeaderConfig.shape) === "swoop";
  const isNoUserClaims = claims.length === 0 && selectedFilters.length === 0 && !isLoading;
  const isFirstLoad = isLoading && isFirstRender;
  const isNoClaimsMatchFilters = claims.length === 0 && selectedFilters.length > 0 && !isLoading;
  const { showClaimsSummaryBackButton, slots } = useClaimsConfig();
  const Banner = slots == null ? void 0 : slots.Banner;
  const handleClearAllFiltersClick = React13.useCallback(() => {
    var _a2;
    (_a2 = containerRef.current) == null ? void 0 : _a2.focus({ preventScroll: true });
  }, []);
  React13.useEffect(
    () => () => {
      clearSelectedFilters();
      clearPagination();
    },
    [clearPagination, clearSelectedFilters]
  );
  if (isFirstLoad) {
    return /* @__PURE__ */ React13.createElement(
      ClaimsSummaryLayout2,
      {
        isSwoop,
        showBackButton: showClaimsSummaryBackButton,
        banner: Banner ? /* @__PURE__ */ React13.createElement(Banner, null) : null
      },
      /* @__PURE__ */ React13.createElement(LoadingIndicator3, null)
    );
  }
  if (isError) {
    return /* @__PURE__ */ React13.createElement(
      ClaimsSummaryLayout2,
      {
        isSwoop,
        showBackButton: showClaimsSummaryBackButton,
        banner: Banner ? /* @__PURE__ */ React13.createElement(Banner, null) : null
      },
      /* @__PURE__ */ React13.createElement(ClaimsErrorState4, { error })
    );
  }
  if (isNoUserClaims) {
    return /* @__PURE__ */ React13.createElement(
      ClaimsSummaryLayout2,
      {
        isSwoop,
        showBackButton: showClaimsSummaryBackButton,
        banner: Banner ? /* @__PURE__ */ React13.createElement(Banner, null) : null
      },
      /* @__PURE__ */ React13.createElement(
        ClaimsErrorState4,
        {
          heading: formatMessage({ id: "CLAIMS_LIST_EMPTY_HEADING" }),
          message: formatMessage({ id: "CLAIMS_LIST_EMPTY_MESSAGE" }),
          error: null
        }
      )
    );
  }
  return /* @__PURE__ */ React13.createElement(
    ClaimsSummaryLayout2,
    {
      isSwoop,
      showBackButton: showClaimsSummaryBackButton,
      banner: Banner ? /* @__PURE__ */ React13.createElement(Banner, null) : null
    },
    /* @__PURE__ */ React13.createElement(Responsive2, { down: "mobileLandscape" }, /* @__PURE__ */ React13.createElement(
      ClaimsSummarySidebarMobileContainer,
      {
        renderHelpfulLinks: /* @__PURE__ */ React13.createElement(ClaimsHelpfulLinksContainer, null)
      }
    )),
    /* @__PURE__ */ React13.createElement(VisuallyHidden2, null, /* @__PURE__ */ React13.createElement(HeadingText, { level: "2", size: "xl", id: CLAIMS_LIST_HEADING_ID }, formatMessage({ id: "CLAIMS_CLAIMS_LIST_HEADING" }))),
    /* @__PURE__ */ React13.createElement(ClaimsFilters, null),
    /* @__PURE__ */ React13.createElement(
      ClaimsSelectedFilters,
      {
        onClearAllFiltersClick: handleClearAllFiltersClick
      }
    ),
    /* @__PURE__ */ React13.createElement(
      Box3,
      {
        css: {
          display: "grid",
          gap: "$oneAndHalf",
          gridTemplateColumns: "4fr 1fr",
          "@mobile": {
            gridTemplateColumns: "1fr"
          },
          position: "relative"
        }
      },
      isNoClaimsMatchFilters && /* @__PURE__ */ React13.createElement(
        ClaimsErrorState4,
        {
          heading: formatMessage({
            id: "CLAIMS_LIST_NO_CLAIMS_MATCH_FILTER_HEADING"
          }),
          message: formatMessage(
            {
              id: "CLAIMS_LIST_NO_CLAIMS_MATCH_FILTER_MESSAGE"
            },
            { filterCount: selectedFilters.length }
          ),
          error: null
        }
      ),
      !isNoClaimsMatchFilters && /* @__PURE__ */ React13.createElement(StackLayout2, { spacing: "$oneAndHalf" }, /* @__PURE__ */ React13.createElement(
        PaginationContainer,
        {
          css: { width: "100%" },
          labelId: CLAIMS_LIST_HEADING_ID,
          selectedPage: currentPage || 1,
          ref: containerRef
        },
        isLoading && /* @__PURE__ */ React13.createElement(ClaimsSkeletonLoaderList2, { numberOfLoaders: pageSize }),
        !isLoading && /* @__PURE__ */ React13.createElement(ClaimsCardList, { claims })
      ), initialized && /* @__PURE__ */ React13.createElement(
        Box3,
        {
          css: {
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            width: "100%"
          }
        },
        /* @__PURE__ */ React13.createElement(
          Pagination,
          {
            isNextPageActiveOverride: isNextButtonEnabled,
            isPrevPageActiveOverride: isPrevButtonEnabled,
            onPageChange: handlePaginationPageChange,
            page: currentPage,
            totalPages
          }
        )
      )),
      /* @__PURE__ */ React13.createElement(Responsive2, { up: "mobileLandscape" }, /* @__PURE__ */ React13.createElement(ClaimsSummarySidebar2, null, /* @__PURE__ */ React13.createElement(ClaimsHelpfulLinksContainer, null)))
    )
  );
}

// src/pages/claims-page/tabs-filters/claims-summary-page-tabs-filters.container.tsx
import * as React24 from "react";
import {
  Box as Box5,
  Responsive as Responsive3,
  StackLayout as StackLayout8,
  VisuallyHidden as VisuallyHidden5,
  HeadingText as HeadingText2
} from "@leagueplatform/genesis-core";
import { Pagination as Pagination2 } from "@leagueplatform/genesis-core-alpha";
import {
  ClaimsErrorState as ClaimsErrorState5,
  ClaimsSkeletonLoaderList as ClaimsSkeletonLoaderList3,
  ClaimsSummaryLayout as ClaimsSummaryLayout3,
  ClaimsSummarySidebar as ClaimsSummarySidebar3
} from "@leagueplatform/claims-ui";
import { usePagination as usePagination4 } from "@leagueplatform/claims-common";
import { useIntl as useIntl12 } from "@leagueplatform/locales";
import { PaginationContainer as PaginationContainer2 } from "@leagueplatform/web-common-components";
import { useConfigProperty as useConfigProperty4 } from "@leagueplatform/core";

// src/components/filters/tabs-and-filters.component.tsx
import React23, { useEffect as useEffect3, useMemo as useMemo2, useCallback as useCallback14 } from "react";
import {
  Box as Box4,
  Divider,
  SkeletonRectangle as SkeletonRectangle2,
  Tabs,
  VisuallyHidden as VisuallyHidden4
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl11 } from "@leagueplatform/locales";
import { getClaimTypeIcon } from "@leagueplatform/claims-ui";
import { useClearPagination as useClearPagination2 } from "@leagueplatform/claims-common";

// src/components/filters/filters.component.tsx
import * as React19 from "react";
import { StackLayout as StackLayout6, UtilityText as UtilityText2 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl8 } from "@leagueplatform/locales";

// src/components/filters/filter/filter.component.tsx
import * as React18 from "react";
import { StackLayout as StackLayout5, Button } from "@leagueplatform/genesis-core";
import { useIntl as useIntl7 } from "@leagueplatform/locales";
import { FormProvider, useForm } from "@leagueplatform/web-common";

// src/components/filters/filter-dropdown/filter-dropdown.component.tsx
import React15, { useMemo } from "react";
import {
  styled,
  Popover,
  GDSPopoverPrimitive
} from "@leagueplatform/genesis-core";
import { uniqueId } from "lodash";

// src/components/filters/hooks/use-clean-up-unapplied-filters.ts
import React14 from "react";
import { useFormContext } from "@leagueplatform/web-common";
var useCleanUpUnappliedFilters = (filterCategoryName, isFilterDropdownOpen) => {
  const { reset } = useFormContext();
  const firstRender = React14.useRef(true);
  React14.useEffect(() => {
    if (!isFilterDropdownOpen && !firstRender.current) {
      reset();
    }
    if (firstRender.current) {
      firstRender.current = false;
    }
  }, [filterCategoryName, isFilterDropdownOpen, reset]);
};

// src/components/filters/filter-dropdown/filter-dropdown.component.tsx
var MAX_POPOVER_HEIGHT = "450px";
var PopoverContent = styled(Popover.Content, {
  zIndex: "$default",
  maxHeight: MAX_POPOVER_HEIGHT,
  overflowY: "auto",
  position: "relative"
});
var FilterTriggerSelect = styled(Popover.Trigger, {
  display: "flex",
  flexDirection: "row-reverse",
  appearance: "none",
  gap: "$half",
  svg: {
    color: "$onSurfaceIconPrimary"
  },
  minWidth: "max-content"
});
var DROPDOWN_MIN_WIDTH = "320px";
function FilterDropdown2({
  children,
  label,
  labelById,
  filterCategoryName,
  onClick: onClickCallback,
  isFilterDropdownOpen,
  setFilterDropdownState,
  isFocusOnButton,
  setIsFocusOnButton
}) {
  const id = uniqueId("filter-dropdown");
  const allSelectedFilters = useSelectedFilters();
  useCleanUpUnappliedFilters(filterCategoryName, isFilterDropdownOpen);
  const toggleFocus = () => setIsFocusOnButton(!isFocusOnButton);
  const toggleDropdown = () => setFilterDropdownState(!isFilterDropdownOpen);
  const numberOfSelectedFilters = useMemo(
    () => allSelectedFilters.filter((filter) => filter.key === filterCategoryName).length,
    [allSelectedFilters, filterCategoryName]
  );
  const labelCount = numberOfSelectedFilters ? `(${numberOfSelectedFilters})` : "";
  return /* @__PURE__ */ React15.createElement(
    Popover.Root,
    {
      onOpenChange: () => toggleDropdown(),
      open: isFilterDropdownOpen
    },
    /* @__PURE__ */ React15.createElement(
      FilterTriggerSelect,
      {
        id,
        "aria-labelledby": `${labelById} ${id}`,
        css: {
          backgroundColor: "$inputBackgroundDefault",
          border: "$borderWidths$thin solid $inputBorderDefault",
          borderRadius: "$medium",
          typography: "$bodyTwo",
          color: "$onSurfaceTextPrimary",
          padding: "$threeQuarters $half",
          paddingInlineStart: "$one",
          "&:hover": {
            borderColor: isFocusOnButton ? "$interactiveFocusInner" : "$inputBorderHovered",
            backgroundColor: "$inputBackgroundHovered"
          },
          '&[class*="GDS"]:focus, &:active, &[aria-expanded="true"]': {
            borderColor: "transparent",
            boxShadow: "inset 0 0 0 $borderWidths$innerFocus $colors$interactiveFocusInner",
            // Visible in Windows high-contrast themes
            outline: "$borderWidths$innerFocus solid transparent",
            backgroundColor: "$inputBackgroundDefault"
          },
          outline: "$borderWidths$innerFocus solid transparent"
        },
        label: `${label} ${labelCount}`,
        icon: isFilterDropdownOpen ? "interfaceChevronUp" : "interfaceChevronDown",
        onClick: (event) => {
          event.currentTarget.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest"
          });
          if (onClickCallback) {
            onClickCallback();
          }
        }
      }
    ),
    /* @__PURE__ */ React15.createElement(GDSPopoverPrimitive.Portal, null, /* @__PURE__ */ React15.createElement(
      PopoverContent,
      {
        avoidCollisions: true,
        align: "start",
        showCloseButton: false,
        onOpenAutoFocus: () => toggleFocus(),
        onCloseAutoFocus: () => toggleFocus(),
        sideOffset: 12,
        css: {
          border: isFilterDropdownOpen ? "$borderWidths$thin solid $interactiveActionPrimary" : "none",
          padding: "$half",
          minWidth: DROPDOWN_MIN_WIDTH,
          overflow: "hidden",
          "@mobile": {
            minWidth: "initial"
          }
        }
      },
      children
    ))
  );
}

// src/components/filters/checkbox-filter-group/checkbox-filter-group.component.tsx
import * as React16 from "react";
import { Fieldset, Checkbox, StackLayout as StackLayout3 } from "@leagueplatform/genesis-core";
import { useFormContext as useFormContext2 } from "@leagueplatform/web-common";
var FILTER_GROUP_MAX_HEIGHT = "250px";
function CheckboxFilterGroup({
  name: filterName,
  label: groupLabel,
  options = []
}) {
  const { register } = useFormContext2();
  const selectedFilters = useSelectedFilters();
  if (options.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React16.createElement(Fieldset, { hideLegend: true, legend: groupLabel }, /* @__PURE__ */ React16.createElement(
    StackLayout3,
    {
      spacing: "$quarter",
      css: {
        alignItems: "baseline",
        maxHeight: FILTER_GROUP_MAX_HEIGHT,
        overflow: "scroll"
      }
    },
    options.map(({ value: optionValue, label }) => {
      const isSelected = selectedFilters.find(
        (filter) => filter.key === filterName && filter.value === optionValue
      );
      return /* @__PURE__ */ React16.createElement("div", { key: optionValue }, /* @__PURE__ */ React16.createElement(
        Checkbox,
        __spreadProps(__spreadValues({}, register(filterName)), {
          id: optionValue,
          label,
          value: optionValue,
          defaultChecked: !!isSelected
        })
      ));
    })
  ));
}

// src/components/filters/radio-filter-group/radio-filter-group.component.tsx
import * as React17 from "react";
import { Fieldset as Fieldset2, Radio, StackLayout as StackLayout4 } from "@leagueplatform/genesis-core";
import { useFormContext as useFormContext3 } from "@leagueplatform/web-common";
var FILTER_GROUP_MAX_HEIGHT2 = "250px";
function RadioFilterGroup({
  label: groupLabel,
  name: filterName,
  options = []
}) {
  const { register } = useFormContext3();
  const selectedFilters = useSelectedFilters();
  if (options.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React17.createElement(Fieldset2, { hideLegend: true, legend: groupLabel }, /* @__PURE__ */ React17.createElement(
    StackLayout4,
    {
      spacing: "$quarter",
      css: {
        alignItems: "baseline",
        maxHeight: FILTER_GROUP_MAX_HEIGHT2,
        overflow: "scroll"
      }
    },
    options.map(({ value: optionValue, label }) => {
      const isSelected = selectedFilters.find(
        (filter) => filter.key === filterName && filter.value === optionValue
      );
      return /* @__PURE__ */ React17.createElement("div", { key: optionValue }, /* @__PURE__ */ React17.createElement(
        Radio,
        __spreadProps(__spreadValues({
          id: optionValue,
          label
        }, register(filterName)), {
          name: filterName,
          value: optionValue,
          defaultChecked: !!isSelected
        })
      ));
    })
  ));
}

// src/components/filters/filter/filter.component.tsx
var FILTER_BY_TEXT_ID2 = "filter-by-id";
function Filter({ value, label, filterKey }) {
  var _a;
  const { formatMessage } = useIntl7();
  const formMethods = useForm();
  const [isFilterDropdownOpen, setFilterDropdownState] = React18.useState(false);
  const [isFocusOnButton, setIsFocusOnButton] = React18.useState(false);
  const resetFilterCategory = useResetFilterCategory();
  const addMultipleSelectedFilters = useReplaceSelectedFiltersFromSameCategory();
  const replaceIndividualFilterFromSameCategory = useReplaceFilterFromSameCategory();
  const selectedFilters = useSelectedFilters();
  const filterOptions = (_a = value == null ? void 0 : value.options) != null ? _a : [];
  const isRequiredFilterCategory = filterOptions.some(
    (option) => option.default
  );
  const handleSubmit = React18.useCallback(
    (selectedFilterValues, options, filterCategoryName) => {
      var _a2, _b;
      if (Array.isArray(selectedFilterValues)) {
        const formattedSelectedFiltersForStore = selectedFilterValues.map(
          (selectedFilterValue, index) => {
            var _a3, _b2;
            return {
              key: filterCategoryName,
              label: (_b2 = (_a3 = options.find((option) => option.value === selectedFilterValue)) == null ? void 0 : _a3.label) != null ? _b2 : "",
              value: selectedFilterValue,
              isDismissible: index && isRequiredFilterCategory || !isRequiredFilterCategory
            };
          }
        );
        if (formattedSelectedFiltersForStore.length > 0) {
          addMultipleSelectedFilters(
            formattedSelectedFiltersForStore,
            filterCategoryName
          );
        } else {
          resetFilterCategory(filterCategoryName);
        }
      }
      if (typeof selectedFilterValues === "string") {
        replaceIndividualFilterFromSameCategory(
          {
            key: filterCategoryName,
            label: (_b = (_a2 = options.find((option) => option.value === selectedFilterValues)) == null ? void 0 : _a2.label) != null ? _b : "",
            value: selectedFilterValues,
            isDismissible: !isRequiredFilterCategory
          },
          filterCategoryName
        );
      }
    },
    [
      addMultipleSelectedFilters,
      isRequiredFilterCategory,
      replaceIndividualFilterFromSameCategory,
      resetFilterCategory
    ]
  );
  const handleResetDropdown = React18.useCallback(() => {
    resetFilterCategory(filterKey);
    setFilterDropdownState(false);
  }, [resetFilterCategory, filterKey]);
  const hasSelected = selectedFilters.some(
    (filter) => filter.key === filterKey
  );
  return /* @__PURE__ */ React18.createElement(
    FormProvider,
    {
      formMethods,
      includesFormElement: false,
      key: filterKey
    },
    /* @__PURE__ */ React18.createElement(
      FilterDropdown2,
      {
        label,
        key: filterKey,
        labelById: FILTER_BY_TEXT_ID2,
        filterCategoryName: filterKey,
        isFilterDropdownOpen,
        setFilterDropdownState,
        isFocusOnButton,
        setIsFocusOnButton
      },
      /* @__PURE__ */ React18.createElement(
        "form",
        {
          onSubmit: formMethods.handleSubmit((selectedDropdownValues) => {
            const currentFilterDropdownValues = selectedDropdownValues[filterKey];
            handleSubmit(currentFilterDropdownValues, filterOptions, filterKey);
            setFilterDropdownState(false);
          })
        },
        value.type === "multi-select" && /* @__PURE__ */ React18.createElement(
          CheckboxFilterGroup,
          {
            options: value.options,
            label,
            name: filterKey
          }
        ),
        value.type === "single-select" && /* @__PURE__ */ React18.createElement(
          RadioFilterGroup,
          {
            options: value.options,
            label,
            name: filterKey
          }
        ),
        /* @__PURE__ */ React18.createElement(
          StackLayout5,
          {
            orientation: "horizontal",
            spacing: "$one",
            css: { padding: "$half" }
          },
          /* @__PURE__ */ React18.createElement(
            Button,
            {
              priority: "secondary",
              size: "medium",
              type: "button",
              css: { flexGrow: 1, justifyContent: "center" },
              onClick: handleResetDropdown,
              disabled: !formMethods.formState.isDirty && !hasSelected
            },
            formatMessage({ id: "RESET_FILTERS" })
          ),
          /* @__PURE__ */ React18.createElement(
            Button,
            {
              priority: "primary",
              size: "medium",
              type: "submit",
              css: { flexGrow: 1, justifyContent: "center" },
              disabled: !formMethods.formState.isDirty
            },
            formatMessage({ id: "SHOW_RESULTS" })
          )
        )
      )
    )
  );
}

// src/components/filters/filters.component.tsx
function Filters({ filters }) {
  const { formatMessage } = useIntl8();
  return /* @__PURE__ */ React19.createElement(StackLayout6, { spacing: "$threeQuarters" }, /* @__PURE__ */ React19.createElement(
    UtilityText2,
    {
      id: FILTER_BY_TEXT_ID2,
      css: { typography: "$overline", color: "$onSurfaceTextSubdued" }
    },
    formatMessage({ id: "FILTER_BY" })
  ), /* @__PURE__ */ React19.createElement(
    StackLayout6,
    {
      orientation: "horizontal",
      css: {
        overflowX: "auto",
        maxWidth: "100%",
        paddingBlockEnd: "$one",
        gap: "$one"
      }
    },
    filters.map(({ value, label, key }) => {
      var _a;
      const isFilterHidden = ((_a = value == null ? void 0 : value.options) == null ? void 0 : _a.length) === 0;
      const isFilterAcceptedType = (value == null ? void 0 : value.type) === "multi-select" || (value == null ? void 0 : value.type) === "single-select";
      if (isFilterHidden || !isFilterAcceptedType) {
        return null;
      }
      return /* @__PURE__ */ React19.createElement(Filter, { value, label, filterKey: key, key });
    })
  ));
}

// src/components/filters/selected-filters/selected-filters.component.tsx
import * as React22 from "react";
import isEqual from "lodash/isEqual";
import { TextAction as TextAction2 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl10 } from "@leagueplatform/locales";

// src/components/filters/filter-tag/filter-tag.component.tsx
import * as React20 from "react";
import {
  Button as Button2,
  UtilityText as UtilityText3,
  VisuallyHidden as VisuallyHidden3
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl9 } from "@leagueplatform/locales";
var FilterTagBaseStyles = {
  typography: "$caption",
  borderRadius: "$large",
  backgroundColor: "$surfaceBackgroundSecondary",
  color: "$onSurfaceTextPrimary",
  borderColor: "$interactiveActionPrimary",
  paddingY: "$half",
  paddingX: "$half",
  whiteSpace: "nowrap",
  borderStyle: "solid",
  borderWidth: "$thin"
};
function FilterTag({
  label,
  onClick: onClickCallback,
  isDismissible
}) {
  const { formatMessage } = useIntl9();
  if (isDismissible) {
    return /* @__PURE__ */ React20.createElement(
      Button2,
      {
        type: "button",
        priority: "secondary",
        icon: "tinyClose",
        onClick: onClickCallback,
        css: __spreadProps(__spreadValues({}, FilterTagBaseStyles), {
          display: "inline-flex",
          flexDirection: "row-reverse",
          justifyContent: "space-between",
          paddingInlineStart: "$none",
          svg: {
            width: "10px",
            height: "10px",
            color: "$interactiveActionPrimary"
          },
          "& > *": {
            paddingInlineStart: "$half",
            paddingInlineEnd: "$none"
          },
          "&:hover": {
            backgroundColor: "$surfaceBackgroundTertiary",
            borderColor: "$interactiveActionPrimary",
            color: "$onSurfaceTextPrimary"
          }
        })
      },
      /* @__PURE__ */ React20.createElement("span", { "aria-hidden": true }, label),
      /* @__PURE__ */ React20.createElement(VisuallyHidden3, null, formatMessage({ id: "REMOVE_X_FILTER" }, { label }))
    );
  }
  return /* @__PURE__ */ React20.createElement(UtilityText3, { css: FilterTagBaseStyles }, label);
}

// src/components/filters/filter-tag/filter-tags-layout.component.tsx
import * as React21 from "react";
import { StackLayout as StackLayout7 } from "@leagueplatform/genesis-core";
function FilterTagsLayout({ children }) {
  return /* @__PURE__ */ React21.createElement(
    StackLayout7,
    {
      orientation: "horizontal",
      spacing: "$threeQuarters $one",
      verticalAlignment: "center",
      css: {
        flexWrap: "wrap",
        maxWidth: "100%",
        paddingBottom: "$one",
        paddingTop: "none",
        "@mobile": {
          flexWrap: "nowrap",
          overflowX: "auto"
        }
      }
    },
    children
  );
}

// src/components/filters/selected-filters/selected-filters.component.tsx
function SelectedFilters({
  onResetFilters: handleResetFilters,
  onClearFilter: handleClearFilter
}) {
  const { formatMessage } = useIntl10();
  const selectedFilters = useSelectedFilters();
  const removeFilter = useRemoveSelectedFilter();
  const resetFilters = useResetFilters();
  const defaultFilters = useDefaultFilters();
  const isOnlyDefaultFiltersSelected = isEqual(selectedFilters, defaultFilters);
  if (!selectedFilters || !selectedFilters.length) {
    return null;
  }
  return /* @__PURE__ */ React22.createElement(FilterTagsLayout, null, selectedFilters.map((filter) => /* @__PURE__ */ React22.createElement(
    FilterTag,
    {
      key: `filterchip-${filter.key}-${filter.value}`,
      label: filter.label,
      isDismissible: filter.isDismissible,
      onClick: () => {
        removeFilter(filter);
        handleClearFilter == null ? void 0 : handleClearFilter();
      }
    }
  )), !isOnlyDefaultFiltersSelected && /* @__PURE__ */ React22.createElement(
    TextAction2,
    {
      as: "button",
      size: "medium",
      onClick: () => {
        resetFilters();
        handleResetFilters == null ? void 0 : handleResetFilters();
      },
      css: {
        whiteSpace: "nowrap"
      }
    },
    formatMessage({ id: "RESET_FILTERS" })
  ));
}

// src/components/filters/tabs-and-filters.component.tsx
var FILTER_BAR_HEIGHT = "78px";
var TAB_LIST_HEIGHT = "46px";
function FilterBar({
  filters,
  onResetFilterFocus: handleResetFilterFocus
}) {
  if (filters.length <= 0) {
    return null;
  }
  return /* @__PURE__ */ React23.createElement(Box4, null, /* @__PURE__ */ React23.createElement(Filters, { filters }), /* @__PURE__ */ React23.createElement(SelectedFilters, { onResetFilters: handleResetFilterFocus }));
}
function TabsAndFilters({
  children,
  tabGroups = [],
  isLoading = false,
  isHidden = false,
  defaultSelectedTab,
  onResetFilterFocus: handleResetFilterFocus
}) {
  var _a;
  const [selectedTab, setSelectedTab] = useSelectedTabState(defaultSelectedTab);
  const { formatMessage } = useIntl11();
  const clearAllFilters = useClearAllFilters();
  const clearPagination = useClearPagination2();
  const populateDefaultFilters = usePopulateDefaultFilters();
  const tabGroupList = tabGroups.map((tabGroup) => ({
    value: tabGroup.id,
    label: tabGroup.label
  })) || [];
  const firstTab = (_a = tabGroupList[0]) == null ? void 0 : _a.value;
  const selectedTabGroup = tabGroups.find(
    (tabGroup) => tabGroup.id === (selectedTab || firstTab)
  );
  const filters = useMemo2(
    () => {
      var _a2, _b;
      return (_b = (_a2 = selectedTabGroup == null ? void 0 : selectedTabGroup.filters) == null ? void 0 : _a2.data) != null ? _b : [];
    },
    [selectedTabGroup == null ? void 0 : selectedTabGroup.filters]
  );
  const defaultFilters = useMemo2(
    () => {
      var _a2;
      return (_a2 = filters == null ? void 0 : filters.reduce) == null ? void 0 : _a2.call(filters, (defaultOptions, filter) => {
        var _a3, _b;
        const defaultOption = (_b = (_a3 = filter.value) == null ? void 0 : _a3.options) == null ? void 0 : _b.find(
          (option) => option.default
        );
        if (defaultOption) {
          defaultOptions.push({
            label: defaultOption.label,
            key: filter.key,
            value: defaultOption.value,
            isDismissible: false
          });
        }
        return defaultOptions;
      }, []);
    },
    [filters]
  );
  useEffect3(() => {
    if (defaultFilters.length > 0) {
      populateDefaultFilters(defaultFilters);
    } else {
      populateDefaultFilters([]);
    }
  }, [defaultFilters, populateDefaultFilters]);
  const handleOnTabClick = useCallback14(
    (tabValue) => {
      clearAllFilters();
      clearPagination();
      setSelectedTab(tabValue);
    },
    [clearAllFilters, clearPagination, setSelectedTab]
  );
  if (isLoading) {
    return /* @__PURE__ */ React23.createElement(React23.Fragment, null, /* @__PURE__ */ React23.createElement(
      SkeletonRectangle2,
      {
        height: TAB_LIST_HEIGHT,
        css: { marginBottom: "$threeQuarters" }
      }
    ), /* @__PURE__ */ React23.createElement(SkeletonRectangle2, { height: FILTER_BAR_HEIGHT }), /* @__PURE__ */ React23.createElement(VisuallyHidden4, null, formatMessage({ id: "CLAIMS_FILTER_LOADING_TEXT" })), children);
  }
  if (tabGroupList.length <= 0 || isHidden) {
    return children;
  }
  if (tabGroupList.length === 1) {
    return /* @__PURE__ */ React23.createElement(React23.Fragment, null, /* @__PURE__ */ React23.createElement(
      FilterBar,
      {
        filters,
        onResetFilterFocus: handleResetFilterFocus
      }
    ), children);
  }
  return /* @__PURE__ */ React23.createElement(
    Tabs.Root,
    {
      defaultValue: defaultSelectedTab || firstTab,
      value: selectedTab,
      onValueChange: handleOnTabClick
    },
    /* @__PURE__ */ React23.createElement(Tabs.TabList, { tabDistribution: "hugContents" }, tabGroupList.map((tab) => /* @__PURE__ */ React23.createElement(
      Tabs.Tab,
      {
        key: tab.value,
        value: tab.value,
        css: {
          paddingX: "$two",
          "@mobile": {
            paddingX: 0
          }
        },
        icon: getClaimTypeIcon(
          tab.value
        )
      },
      tab.label
    ))),
    /* @__PURE__ */ React23.createElement(Divider, { css: { margin: "$none", marginBottom: "$two" } }),
    tabGroupList.map((tab) => /* @__PURE__ */ React23.createElement(
      Tabs.TabPanel,
      {
        value: tab.value,
        key: tab.value,
        css: { padding: "$none" }
      },
      /* @__PURE__ */ React23.createElement(
        FilterBar,
        {
          filters,
          onResetFilterFocus: handleResetFilterFocus
        }
      ),
      children
    ))
  );
}

// src/pages/claims-page/tabs-filters/hooks/use-clear-pagination-and-filters-on-unmount.hook.ts
import { usePagination as usePagination2 } from "@leagueplatform/claims-common";
import { useEffect as useEffect4 } from "react";
function useClearPaginationAndFiltersOnUnmount() {
  const clearSelectedFilters = useClearAllFilters();
  const { clearPagination } = usePagination2();
  useEffect4(
    () => () => {
      clearSelectedFilters();
      clearPagination();
    },
    [clearPagination, clearSelectedFilters]
  );
}

// src/pages/claims-page/tabs-filters/hooks/use-combined-filters-and-search-query.hook.ts
import {
  usePaginationValue
} from "@leagueplatform/claims-common";
import { useSearchParams as useSearchParams2 } from "@leagueplatform/web-common";

// src/pages/claims-page/hooks/use-claims-filters-query-v2.hook.ts
import { useQuery as useQuery5 } from "react-query";
import {
  GET_CLAIMS_FILTERS_V2_PATH,
  getDeserializedClaimsFiltersV2
} from "@leagueplatform/claims-api";
var DEFAULT_STALE_TIME2 = -1;
function useClaimsFiltersQueryV2(options) {
  return useQuery5(
    [GET_CLAIMS_FILTERS_V2_PATH],
    () => getDeserializedClaimsFiltersV2(),
    __spreadValues({ staleTime: DEFAULT_STALE_TIME2 }, options)
  );
}

// src/pages/claims-page/hooks/use-post-claims-search-query-v2.hook.ts
import { useQuery as useQuery6 } from "react-query";
import {
  postDeserializedClaimsSearchV2,
  POST_CLAIMS_SEARCH_PATH_V2
} from "@leagueplatform/claims-api";
var DEFAULT_VARIABLES2 = {
  body: {
    data: {
      id: "",
      type: "claims-search",
      attributes: { filters: [] }
    }
  }
};
function usePostClaimsSearchQueryV2(variables = DEFAULT_VARIABLES2, options) {
  return useQuery6(
    [POST_CLAIMS_SEARCH_PATH_V2, variables],
    () => postDeserializedClaimsSearchV2(variables),
    __spreadValues({ staleTime: Infinity }, options)
  );
}

// src/pages/claims-page/tabs-filters/hooks/use-combined-filters-and-search-query.hook.ts
import { useEffect as useEffect5 } from "react";

// src/utils/format-filters.util.ts
function formatFilters(filters) {
  return filters.reduce((acc, { key, value }) => {
    const existingFilterIndex = acc.findIndex((f) => f.key === key);
    if (existingFilterIndex > -1) {
      acc[existingFilterIndex].value.push(value);
    } else {
      acc.push({ key, value: [value] });
    }
    return acc;
  }, []);
}

// src/utils/get-filters-for-search.util.ts
function getFiltersForSearch({
  filters,
  selectedTabId,
  pageOffset,
  pageSize,
  cursor
}) {
  let filtersValue;
  const consolidatedFilters = formatFilters(filters);
  if (selectedTabId) {
    filtersValue = [
      {
        key: selectedTabId
      }
    ];
  } else {
    filtersValue = consolidatedFilters;
  }
  let queryParams = {};
  if (pageOffset) {
    queryParams = __spreadProps(__spreadValues({}, queryParams), { "page[offset]": `${pageOffset}` });
  }
  if (pageSize) {
    queryParams = __spreadProps(__spreadValues({}, queryParams), { "page[size]": pageSize });
  }
  if (cursor) {
    queryParams = __spreadProps(__spreadValues({}, queryParams), { "page[cursor]": cursor });
  }
  const body = {
    data: {
      type: "claims-search",
      attributes: {
        filters: filtersValue
      }
    }
  };
  if (selectedTabId) {
    body.data.relationships = {
      filters: {
        data: consolidatedFilters.map((filter) => ({
          id: filter.key,
          type: "filter"
        }))
      }
    };
    body.included = consolidatedFilters.map((filter) => ({
      id: filter.key,
      type: "filter",
      attributes: {
        key: filter.key,
        value: filter.value
      }
    }));
  }
  return { body, queryParams };
}

// src/pages/claims-page/tabs-filters/hooks/use-combined-filters-and-search-query.hook.ts
function useCombinedFiltersAndSearchQuery({
  initializePagination
}) {
  var _a;
  const claimTypeParam = useSearchParams2("claimType");
  const { selectedFilters, selectedTab, setSelectedTab } = useSelectedFilterStore();
  const pagination = usePaginationValue();
  const filtersQuery = useClaimsFiltersQueryV2({
    select: (res) => res.data,
    onSuccess: (data) => {
      if (claimTypeParam && (data == null ? void 0 : data.find((filter) => filter.key === claimTypeParam))) {
        setSelectedTab(claimTypeParam);
      } else if (!selectedTab) {
        setSelectedTab(data == null ? void 0 : data[0].key);
      }
    }
  });
  const variables = getFiltersForSearch({
    filters: selectedFilters,
    selectedTabId: selectedTab,
    pageOffset: pagination == null ? void 0 : pagination.offset,
    pageSize: pagination == null ? void 0 : pagination.pageSize,
    cursor: pagination == null ? void 0 : pagination.cursor
  });
  const searchQuery = usePostClaimsSearchQueryV2(variables, {
    enabled: filtersQuery.isSuccess
  });
  const meta = (_a = searchQuery.data) == null ? void 0 : _a.meta;
  useEffect5(() => {
    if (meta == null ? void 0 : meta.pagination) {
      initializePagination(meta.pagination);
    }
  }, [meta == null ? void 0 : meta.pagination, initializePagination]);
  return {
    filtersQuery,
    searchQuery,
    isLoading: filtersQuery.isLoading || searchQuery.isLoading,
    isError: filtersQuery.isError || searchQuery.isError,
    errors: [filtersQuery.error, searchQuery.error]
  };
}

// src/pages/claims-page/tabs-filters/hooks/use-claims-pagination-analytics.hook.ts
import { useCallback as useCallback15, useEffect as useEffect6 } from "react";
import {
  EVENT_NAME as EVENT_NAME9,
  PRODUCT_AREA as PRODUCT_AREA9,
  SCREEN_NAMES as SCREEN_NAMES9,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA9,
  trackAnalyticsEvent as trackAnalyticsEvent9
} from "@leagueplatform/analytics";
function useClaimsPaginationAnalytics(pagination) {
  var _a, _b;
  const { currentPage, totalPages, initializePagination, onPageChange } = pagination;
  const { searchQuery } = useCombinedFiltersAndSearchQuery(pagination);
  const meta = (_a = searchQuery.data) == null ? void 0 : _a.meta;
  const handleClaimsLoadedSuccess = useCallback15(() => {
    var _a2;
    trackAnalyticsEvent9(EVENT_NAME9.SCREEN_LOADED, {
      detail: "new claims added",
      product_area: PRODUCT_AREA9.CLAIMS,
      sub_product_area: SUB_PRODUCT_AREA9.SUMMARY,
      screen_name: SCREEN_NAMES9.SUMMARY,
      current_page: currentPage,
      total_pages: totalPages,
      paginate_type: (_a2 = meta == null ? void 0 : meta.pagination) == null ? void 0 : _a2.strategy
    });
  }, [currentPage, (_b = meta == null ? void 0 : meta.pagination) == null ? void 0 : _b.strategy, totalPages]);
  useEffect6(() => {
    if (meta == null ? void 0 : meta.pagination) {
      handleClaimsLoadedSuccess();
    }
  }, [initializePagination, meta == null ? void 0 : meta.pagination, handleClaimsLoadedSuccess]);
  const handlePaginationPageChange = useCallback15(
    (newPage) => {
      if (onPageChange) {
        onPageChange(newPage);
        trackAnalyticsEvent9(EVENT_NAME9.BUTTON_CLICKED, {
          product_area: PRODUCT_AREA9.CLAIMS,
          sub_product_area: SUB_PRODUCT_AREA9.SUMMARY,
          screen_name: SCREEN_NAMES9.SUMMARY,
          current_page: newPage.pageNumber,
          total_pages: totalPages,
          paginate_type: newPage.buttonType
        });
      }
    },
    [onPageChange, totalPages]
  );
  return { handlePaginationPageChange };
}

// src/pages/claims-page/tabs-filters/claims-summary-page-tabs-filters.container.tsx
var CLAIMS_LIST_HEADING_ID2 = "claims-list-heading-id";
function ClaimsSummaryPageTabFilters() {
  var _a;
  const { formatMessage } = useIntl12();
  const { selectedFilters } = useSelectedFilterStore();
  const pagination = usePagination4();
  const {
    currentPage,
    initialized,
    isNextButtonEnabled,
    isPrevButtonEnabled,
    pageSize,
    totalPages
  } = pagination;
  const { filtersQuery, searchQuery, isLoading, isError, errors } = useCombinedFiltersAndSearchQuery(pagination);
  const claims = ((_a = searchQuery.data) == null ? void 0 : _a.data) || [];
  const { handlePaginationPageChange } = useClaimsPaginationAnalytics(pagination);
  const containerRef = React24.useRef(null);
  const handleClearAllFiltersClick = React24.useCallback(() => {
    var _a2;
    (_a2 = containerRef.current) == null ? void 0 : _a2.focus({ preventScroll: true });
  }, []);
  const pageHeaderConfig = useConfigProperty4("core.ui.components.pageHeader");
  const isSwoop = (pageHeaderConfig == null ? void 0 : pageHeaderConfig.shape) === "swoop";
  const isNoUserClaims = claims.length === 0 && selectedFilters.length === 0 && !isLoading;
  const isNoClaimsMatchFilters = claims.length === 0 && selectedFilters.length > 0 && !isLoading;
  const { showClaimsSummaryBackButton, slots } = useClaimsConfig();
  const Banner = slots == null ? void 0 : slots.Banner;
  useClearPaginationAndFiltersOnUnmount();
  if (isError) {
    return /* @__PURE__ */ React24.createElement(
      ClaimsSummaryLayout3,
      {
        isSwoop,
        showBackButton: showClaimsSummaryBackButton,
        banner: Banner ? /* @__PURE__ */ React24.createElement(Banner, null) : null
      },
      /* @__PURE__ */ React24.createElement(TabsAndFilters, { tabGroups: filtersQuery.data }, /* @__PURE__ */ React24.createElement(ClaimsErrorState5, { error: errors }))
    );
  }
  if (isNoUserClaims) {
    return /* @__PURE__ */ React24.createElement(
      ClaimsSummaryLayout3,
      {
        isSwoop,
        showBackButton: showClaimsSummaryBackButton,
        banner: Banner ? /* @__PURE__ */ React24.createElement(Banner, null) : null
      },
      /* @__PURE__ */ React24.createElement(TabsAndFilters, { tabGroups: filtersQuery.data }, /* @__PURE__ */ React24.createElement(
        ClaimsErrorState5,
        {
          heading: formatMessage({ id: "CLAIMS_LIST_EMPTY_HEADING" }),
          message: formatMessage({ id: "CLAIMS_LIST_EMPTY_MESSAGE" }),
          error: null
        }
      ))
    );
  }
  return /* @__PURE__ */ React24.createElement(
    ClaimsSummaryLayout3,
    {
      isSwoop,
      showBackButton: showClaimsSummaryBackButton,
      banner: Banner ? /* @__PURE__ */ React24.createElement(Banner, null) : null
    },
    /* @__PURE__ */ React24.createElement(Responsive3, { down: "mobileLandscape" }, /* @__PURE__ */ React24.createElement(
      ClaimsSummarySidebarMobileContainer,
      {
        renderHelpfulLinks: /* @__PURE__ */ React24.createElement(ClaimsHelpfulLinksContainer, null)
      }
    )),
    /* @__PURE__ */ React24.createElement(VisuallyHidden5, null, /* @__PURE__ */ React24.createElement(HeadingText2, { level: "2", size: "xl", id: CLAIMS_LIST_HEADING_ID2 }, formatMessage({ id: "CLAIMS_CLAIMS_LIST_HEADING" }))),
    /* @__PURE__ */ React24.createElement(
      TabsAndFilters,
      {
        tabGroups: filtersQuery.data,
        isLoading: filtersQuery.isLoading,
        onResetFilterFocus: handleClearAllFiltersClick
      },
      /* @__PURE__ */ React24.createElement(
        Box5,
        {
          css: {
            display: "grid",
            gap: "$oneAndHalf",
            gridTemplateColumns: "4fr 1fr",
            "@mobile": {
              gridTemplateColumns: "1fr"
            },
            position: "relative"
          }
        },
        isNoClaimsMatchFilters && /* @__PURE__ */ React24.createElement(
          ClaimsErrorState5,
          {
            heading: formatMessage({
              id: "CLAIMS_LIST_NO_CLAIMS_MATCH_FILTER_HEADING"
            }),
            message: formatMessage(
              {
                id: "CLAIMS_LIST_NO_CLAIMS_MATCH_FILTER_MESSAGE"
              },
              { filterCount: selectedFilters.length }
            ),
            error: null
          }
        ),
        !isNoClaimsMatchFilters && /* @__PURE__ */ React24.createElement(StackLayout8, { spacing: "$oneAndHalf" }, /* @__PURE__ */ React24.createElement(
          PaginationContainer2,
          {
            css: { width: "100%" },
            labelId: CLAIMS_LIST_HEADING_ID2,
            selectedPage: currentPage || 1,
            ref: containerRef
          },
          isLoading && /* @__PURE__ */ React24.createElement(ClaimsSkeletonLoaderList3, { numberOfLoaders: pageSize }),
          !isLoading && /* @__PURE__ */ React24.createElement(ClaimsCardList, { claims })
        ), initialized && /* @__PURE__ */ React24.createElement(
          Box5,
          {
            css: {
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
              width: "100%"
            }
          },
          /* @__PURE__ */ React24.createElement(
            Pagination2,
            {
              isNextPageActiveOverride: isNextButtonEnabled,
              isPrevPageActiveOverride: isPrevButtonEnabled,
              onPageChange: handlePaginationPageChange,
              page: currentPage,
              totalPages
            }
          )
        )),
        /* @__PURE__ */ React24.createElement(Responsive3, { up: "mobileLandscape" }, /* @__PURE__ */ React24.createElement(ClaimsSummarySidebar3, null, /* @__PURE__ */ React24.createElement(ClaimsHelpfulLinksContainer, null)))
      )
    )
  );
}

// src/pages/claims-page/claims-summary-page.container.tsx
function ClaimsSummaryPageContainer() {
  const { enableDynamicFilters, enableTabFilters } = useClaimsConfig();
  const { formatMessage } = useIntl13();
  useDocumentTitle(formatMessage({ id: "CLAIMS_CLAIMS_SUMMARY_PAGE_TITLE" }));
  usePageViewAnalytics3({
    product_area: PRODUCT_AREA10.CLAIMS,
    sub_product_area: SUB_PRODUCT_AREA10.SUMMARY,
    screen_name: SCREEN_NAMES10.SUMMARY
  });
  if (enableTabFilters) {
    return /* @__PURE__ */ React25.createElement(ClaimsSummaryPageTabFilters, null);
  }
  if (enableDynamicFilters) {
    return /* @__PURE__ */ React25.createElement(ClaimsSummaryPageDynamicFilters, null);
  }
  return /* @__PURE__ */ React25.createElement(ClaimsSummaryPageStaticFilters, null);
}

// src/components/claims-recent-card-list/claims-recent-card-list.component.tsx
import * as React26 from "react";
import { useIntl as useIntl14 } from "@leagueplatform/locales";
import {
  StackLayout as StackLayout9,
  Box as Box6,
  TextAction as TextAction3,
  ParagraphText,
  SkeletonRectangle as SkeletonRectangle3
} from "@leagueplatform/genesis-core";
import { SectionHeader } from "@leagueplatform/genesis-core-alpha";
import {
  PRODUCT_AREA as PRODUCT_AREA11,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA11,
  SCREEN_NAMES as SCREEN_NAMES11,
  usePageViewAnalytics as usePageViewAnalytics4,
  trackAnalyticsEvent as trackAnalyticsEvent10,
  EVENT_NAME as EVENT_NAME10
} from "@leagueplatform/analytics";
import { LinkLegacy as RouterLink } from "@leagueplatform/routing";
import { LEAGUE_MODULE_NAMES, getModulePath } from "@leagueplatform/core";
import { ClaimCard } from "@leagueplatform/claims-ui";

// src/constants/claims-params.constants.ts
var CLAIMS_RECENT_PARAM = "?h=1";

// src/components/claims-recent-card-list/claims-recent-card-list.component.tsx
var RECENT_CLAIMS_SKELETON_HEIGHT = "150px";
function RecentClaimsWrapper({ children }) {
  usePageViewAnalytics4({
    product_area: PRODUCT_AREA11.CLAIMS,
    sub_product_area: SUB_PRODUCT_AREA11.RECENT_CLAIMS_WIDGET,
    screen_name: SCREEN_NAMES11.RECENT_CLAIMS_WIDGET
  });
  const { formatMessage } = useIntl14();
  return /* @__PURE__ */ React26.createElement(
    StackLayout9,
    {
      orientation: "vertical",
      verticalAlignment: "top",
      horizontalAlignment: "stretch",
      spacing: "$oneAndHalf"
    },
    /* @__PURE__ */ React26.createElement(
      Box6,
      {
        css: {
          display: "flex",
          alignItems: "baseline",
          justifyContent: "space-between"
        }
      },
      /* @__PURE__ */ React26.createElement(
        SectionHeader,
        {
          title: formatMessage({ id: "RECENT_CLAIMS" }),
          headingLevel: "2",
          isCtaLabelledByHeading: true,
          textAction: /* @__PURE__ */ React26.createElement(
            TextAction3,
            {
              as: RouterLink,
              to: `${getModulePath(
                LEAGUE_MODULE_NAMES.claims
              )}/${CLAIMS_RECENT_PARAM}`,
              onClick: () => trackAnalyticsEvent10(EVENT_NAME10.BUTTON_CLICKED, {
                product_area: PRODUCT_AREA11.CLAIMS,
                sub_product_area: SUB_PRODUCT_AREA11.RECENT_CLAIMS_WIDGET,
                screen_name: SCREEN_NAMES11.RECENT_CLAIMS_WIDGET,
                detail: "view all"
              })
            },
            formatMessage({ id: "CLAIMS_VIEW_ALL" })
          )
        }
      )
    ),
    children
  );
}
var RecentClaimsCardList = () => {
  const { isLoading, isError, data: claims } = useGetRecentWidgetClaimsQuery();
  const { formatMessage } = useIntl14();
  const handleCardClick = React26.useCallback(() => {
    trackAnalyticsEvent10(EVENT_NAME10.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA11.CLAIMS,
      sub_product_area: SUB_PRODUCT_AREA11.RECENT_CLAIMS_WIDGET,
      screen_name: SCREEN_NAMES11.RECENT_CLAIMS_WIDGET,
      detail: "claim"
    });
  }, []);
  if (isLoading) {
    return /* @__PURE__ */ React26.createElement(RecentClaimsWrapper, null, /* @__PURE__ */ React26.createElement(
      SkeletonRectangle3,
      {
        height: RECENT_CLAIMS_SKELETON_HEIGHT,
        css: { backgroundColor: "$surfaceBackgroundSecondary" },
        borderRadius: "$medium"
      }
    ));
  }
  if (isError || (claims == null ? void 0 : claims.length) === 0) {
    return /* @__PURE__ */ React26.createElement(RecentClaimsWrapper, null, /* @__PURE__ */ React26.createElement(ParagraphText, null, formatMessage({ id: "RECENT_CLAIMS_LIST_EMPTY" })));
  }
  return /* @__PURE__ */ React26.createElement(RecentClaimsWrapper, null, /* @__PURE__ */ React26.createElement(
    StackLayout9,
    {
      spacing: "$oneAndHalf",
      horizontalAlignment: "stretch",
      css: { marginBottom: "$oneAndHalf" }
    },
    claims == null ? void 0 : claims.map(
      ({
        identifier,
        patientName,
        providerName,
        serviceDate,
        status,
        owed,
        type
      }) => /* @__PURE__ */ React26.createElement(
        ClaimCard,
        {
          onClick: handleCardClick,
          key: identifier,
          identifier,
          patientName,
          providerName,
          serviceDate,
          status,
          owed,
          claimType: type
        }
      )
    )
  ));
};

// src/claims.routes.tsx
import React30 from "react";
import { Routes, Route } from "@leagueplatform/routing";

// src/pages/claim-details-page/claim-details-page.tsx
import React29, { useEffect as useEffect7 } from "react";
import { useIntl as useIntl17 } from "@leagueplatform/locales";
import isEmpty from "lodash/isEmpty";
import {
  StackLayout as StackLayout10,
  StackItem,
  Box as Box7,
  Card,
  Icon,
  HeadingText as HeadingText3,
  ParagraphText as ParagraphText2,
  Responsive as Responsive4
} from "@leagueplatform/genesis-core";
import { getModulePath as getModulePath3, LEAGUE_MODULE_NAMES as LEAGUE_MODULE_NAMES3 } from "@leagueplatform/core";
import {
  EVENT_NAME as EVENT_NAME13,
  SCREEN_NAMES as SCREEN_NAMES14,
  PRODUCT_AREA as PRODUCT_AREA14,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA14,
  trackAnalyticsEvent as trackAnalyticsEvent13
} from "@leagueplatform/analytics";
import { useGoBack, useDocumentTitle as useDocumentTitle2 } from "@leagueplatform/web-common";
import { useDownloadExplanationOfBenefits } from "@leagueplatform/claims-common";
import {
  ClaimsErrorState as ClaimsErrorState6,
  ClaimsBackButton,
  ClaimStatusPreview,
  ClaimUserCostCard,
  TotalCostOverview,
  ServiceDetails
} from "@leagueplatform/claims-ui";
import { SectionHeader as SectionHeader2 } from "@leagueplatform/genesis-core-alpha";
import { LoadingIndicator as LoadingIndicator4 } from "@leagueplatform/web-common-components";

// src/pages/claim-details-page/hooks/get-claim-details-query.hook.ts
import { useQuery as useQuery7 } from "react-query";
import {
  getDeserializedClaimDetails,
  GET_CLAIM_DETAILS_PATH
} from "@leagueplatform/claims-api";
import { useParamsLegacy as useParams } from "@leagueplatform/routing";
var STALE_TIME2 = 1e3 * 60 * 5;
function useGetClaimDetailsQuery() {
  const { claimId } = useParams();
  return useQuery7(
    [GET_CLAIM_DETAILS_PATH, claimId],
    () => getDeserializedClaimDetails({
      pathParams: { claimId }
    }),
    { staleTime: STALE_TIME2 }
  );
}

// src/pages/claim-details-page/components/plan-progress-card/plan-progress-card.component.tsx
import * as React27 from "react";
import { useIntl as useIntl15 } from "@leagueplatform/locales";
import { SupportingCard } from "@leagueplatform/claims-ui";
import { LEAGUE_MODULE_NAMES as LEAGUE_MODULE_NAMES2, getModulePath as getModulePath2 } from "@leagueplatform/core";
import {
  EVENT_NAME as EVENT_NAME11,
  PRODUCT_AREA as PRODUCT_AREA12,
  SCREEN_NAMES as SCREEN_NAMES12,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA12,
  trackAnalyticsEvent as trackAnalyticsEvent11
} from "@leagueplatform/analytics";
function PlanProgressCard() {
  var _a;
  const { formatMessage } = useIntl15();
  const { data } = useGetClaimDetailsQuery();
  const walletRoute = getModulePath2(LEAGUE_MODULE_NAMES2.wallet);
  const benefitId = (_a = data == null ? void 0 : data.benefit) == null ? void 0 : _a.id;
  const handleCardClick = React27.useCallback(() => {
    trackAnalyticsEvent11(EVENT_NAME11.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA12.CLAIMS,
      sub_product_area: SUB_PRODUCT_AREA12.CLAIM_DETAILS,
      screen_name: SCREEN_NAMES12.CLAIM_DETAILS,
      detail: "view plan progress"
    });
  }, []);
  return /* @__PURE__ */ React27.createElement(
    SupportingCard,
    {
      title: formatMessage({ id: "PLAN_PROGRESS" }),
      description: formatMessage({
        id: "CLAIMS_PLAN_PROGRESS_DESCRIPTION"
      }),
      routeCopy: formatMessage({ id: "VIEW_PLAN_PROGRESS" }),
      route: `${walletRoute}/${benefitId}`,
      onClick: handleCardClick
    }
  );
}

// src/pages/claim-details-page/components/support-card/support-card.component.tsx
import * as React28 from "react";
import {
  trackAnalyticsEvent as trackAnalyticsEvent12,
  EVENT_NAME as EVENT_NAME12,
  PRODUCT_AREA as PRODUCT_AREA13,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA13,
  SCREEN_NAMES as SCREEN_NAMES13
} from "@leagueplatform/analytics";
import { SupportingCard as SupportingCard2 } from "@leagueplatform/claims-ui";
import { useIntl as useIntl16 } from "@leagueplatform/locales";
function SupportCard() {
  const { formatMessage } = useIntl16();
  const { supportLink } = useClaimsConfig();
  const handleCardClick = React28.useCallback(() => {
    trackAnalyticsEvent12(EVENT_NAME12.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA13.CLAIMS,
      sub_product_area: SUB_PRODUCT_AREA13.CLAIM_DETAILS,
      screen_name: SCREEN_NAMES13.CLAIM_DETAILS,
      detail: "get support"
    });
  }, []);
  if (!supportLink) {
    return null;
  }
  return /* @__PURE__ */ React28.createElement(
    SupportingCard2,
    {
      title: formatMessage({ id: "SUPPORT" }),
      description: formatMessage({
        id: "MESSAGE_WITH_A_MEMBER"
      }),
      routeCopy: formatMessage({ id: "GET_SUPPORT" }),
      route: supportLink,
      onClick: handleCardClick
    }
  );
}

// src/pages/claim-details-page/claim-details-page.tsx
var CLAIM_DETAILS_MAX_WIDTH = "1400px";
function ClaimDetailsPage() {
  var _a;
  useEffect7(() => {
    trackAnalyticsEvent13(EVENT_NAME13.SCREEN_LOADED, {
      product_area: PRODUCT_AREA14.CLAIMS,
      sub_product_area: SUB_PRODUCT_AREA14.CLAIM_DETAILS,
      screen_name: SCREEN_NAMES14.CLAIM_DETAILS
    });
  }, []);
  const {
    data: claimDetailsData,
    isLoading,
    isError,
    isSuccess,
    error
  } = useGetClaimDetailsQuery();
  const { refetch: downloadEOB, isFetching: isDownloadingEOB } = useDownloadExplanationOfBenefits();
  const { formatMessage, $tifelse } = useIntl17();
  const goBack = useGoBack(getModulePath3(LEAGUE_MODULE_NAMES3.claims));
  const { supportLink, showTotalCostOverviewAndAdditionalResources } = useClaimsConfig();
  const pageTitle = $tifelse(
    !(claimDetailsData == null ? void 0 : claimDetailsData.providerName),
    "CLAIMS_CLAIMS_DETAIL_PAGE_TITLE",
    "CLAIMS_CLAIMS_DETAIL_WITH_TITLE_PAGE_TITLE",
    { title: claimDetailsData == null ? void 0 : claimDetailsData.providerName }
  );
  useDocumentTitle2(pageTitle);
  const hasSupportLink = Boolean(supportLink);
  const onEOBDownloadClick = React29.useCallback(() => {
    downloadEOB();
    trackAnalyticsEvent13(EVENT_NAME13.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA14.CLAIMS,
      sub_product_area: SUB_PRODUCT_AREA14.CLAIM_DETAILS,
      screen_name: SCREEN_NAMES14.CLAIM_DETAILS,
      detail: "download explanation of benefits"
    });
  }, [downloadEOB]);
  const trackCostDetailsAnalytics = React29.useCallback(
    (tooltipLabel) => {
      trackAnalyticsEvent13(EVENT_NAME13.BUTTON_CLICKED, {
        product_area: PRODUCT_AREA14.CLAIMS,
        sub_product_area: SUB_PRODUCT_AREA14.CLAIM_DETAILS,
        screen_name: SCREEN_NAMES14.CLAIM_DETAILS,
        detail: formatMessage({ id: "VIEW_TOOLTIP" }, { tooltipLabel })
      });
    },
    [formatMessage]
  );
  const trackCostDetailsToggleAction = React29.useCallback(() => {
    trackAnalyticsEvent13(EVENT_NAME13.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA14.CLAIMS,
      sub_product_area: SUB_PRODUCT_AREA14.CLAIM_DETAILS,
      screen_name: SCREEN_NAMES14.CLAIM_DETAILS,
      detail: "view show/hide cost details"
    });
  }, []);
  const { getTotalCostOverviewVisibilityForClaim, slots } = useClaimsConfig();
  const ServiceDetailsBanner = slots == null ? void 0 : slots.ServiceDetailsBanner;
  if (isLoading) {
    return /* @__PURE__ */ React29.createElement(LoadingIndicator4, null);
  }
  if (isError || !isSuccess) {
    return /* @__PURE__ */ React29.createElement(
      Box7,
      {
        css: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "50vh"
        }
      },
      /* @__PURE__ */ React29.createElement(ClaimsErrorState6, { error })
    );
  }
  const isPending = claimDetailsData.status === "pending";
  const userCost = (_a = claimDetailsData.totals) == null ? void 0 : _a.owed;
  const showTotalCostOverviewSection = !isPending && showTotalCostOverviewAndAdditionalResources;
  const {
    status,
    serviceDate,
    paidDate,
    providerName,
    providerServiceNetwork,
    patientName,
    identifier,
    claimType,
    services,
    groupId,
    totals,
    eob,
    createdDate
  } = claimDetailsData;
  const showEobDownloadButton = Boolean(eob == null ? void 0 : eob.showDownloadButton);
  const showTotalCostOverviewGraph = getTotalCostOverviewVisibilityForClaim({
    claimType,
    status,
    createdDate,
    paidDate,
    serviceDate,
    charged: totals == null ? void 0 : totals.charged,
    memberDiscount: totals == null ? void 0 : totals.memberDiscount,
    otherInsurancePaid: totals == null ? void 0 : totals.otherInsurancePaid,
    owed: totals == null ? void 0 : totals.owed,
    planPaid: totals == null ? void 0 : totals.planPaid,
    providerServiceNetwork
  });
  return /* @__PURE__ */ React29.createElement(
    StackLayout10,
    {
      horizontalAlignment: "center",
      css: {
        padding: "$none $two",
        "@mobile": {
          padding: "$none"
        }
      }
    },
    /* @__PURE__ */ React29.createElement(
      Box7,
      {
        css: {
          position: "relative",
          maxWidth: CLAIM_DETAILS_MAX_WIDTH,
          width: "100%",
          padding: "59px $oneAndHalf",
          "@mobile": {
            padding: "32px $oneAndHalf",
            position: "static"
          }
        }
      },
      /* @__PURE__ */ React29.createElement(
        ClaimsBackButton,
        {
          as: "a",
          width: "hugContents",
          href: "#",
          onClick: (e) => {
            e.preventDefault();
            goBack();
          },
          id: "go-back",
          css: {
            position: "absolute",
            insetInlineStart: "-16px",
            top: "57px",
            "@mobile": {
              display: "inline-block",
              position: "static",
              marginBottom: "$oneAndHalf"
            }
          }
        },
        /* @__PURE__ */ React29.createElement(
          Icon,
          {
            icon: "interfaceArrowBack",
            size: {
              "@initial": "$oneAndHalf",
              "@mobile": "$one"
            },
            tint: "$onSurfaceIconPrimary",
            label: formatMessage({ id: "GO_BACK" })
          }
        )
      ),
      /* @__PURE__ */ React29.createElement(StackLayout10, { horizontalAlignment: "stretch", spacing: "$twoAndHalf" }, /* @__PURE__ */ React29.createElement(
        StackLayout10,
        {
          spacing: {
            "@initial": "$oneAndHalf",
            "@mobile": "$two",
            "@mobileLandscape": "$two",
            "@tablet": "$two"
          },
          horizontalAlignment: "stretch",
          orientation: {
            "@initial": "horizontal",
            "@mobile": "vertical",
            "@mobileLandscape": "vertical",
            "@tablet": "vertical"
          }
        },
        /* @__PURE__ */ React29.createElement(StackItem, { growFactor: 2 }, /* @__PURE__ */ React29.createElement(
          ClaimStatusPreview,
          {
            claimDate: serviceDate,
            status,
            providerName,
            providerServiceNetwork,
            patientName,
            identifier,
            claimType,
            groupId,
            isPending,
            showEobDownloadButton,
            onEOBDownloadClick,
            isFetching: isDownloadingEOB
          }
        )),
        /* @__PURE__ */ React29.createElement(
          Card.Flat,
          {
            backgroundColor: "highlight",
            css: { padding: "$oneAndHalf" }
          },
          /* @__PURE__ */ React29.createElement(ClaimUserCostCard, { isPending, userCost })
        )
      ), showTotalCostOverviewSection && /* @__PURE__ */ React29.createElement(StackLayout10, { horizontalAlignment: "stretch" }, /* @__PURE__ */ React29.createElement(HeadingText3, { level: "2", size: "lg", css: { marginBottom: "$half" } }, formatMessage({ id: "TOTAL_COST_OVERVIEW" })), /* @__PURE__ */ React29.createElement(
        ParagraphText2,
        {
          size: "base",
          emphasis: "subtle",
          css: { paddingBottom: "$half" }
        },
        formatMessage({ id: "TOTAL_COST_DESCRIPTION" })
      ), /* @__PURE__ */ React29.createElement(
        StackLayout10,
        {
          spacing: "$oneAndHalf",
          verticalAlignment: "stretch",
          horizontalAlignment: "stretch",
          orientation: "horizontal"
        },
        totals && /* @__PURE__ */ React29.createElement(StackItem, { growFactor: 2 }, /* @__PURE__ */ React29.createElement(
          Card.Flat,
          {
            backgroundColor: "primary",
            css: {
              borderWidth: "$thin",
              borderStyle: "solid",
              borderColor: "$onSurfaceBorderSubdued"
            }
          },
          /* @__PURE__ */ React29.createElement(Card.Section, null, /* @__PURE__ */ React29.createElement(
            TotalCostOverview,
            {
              totals,
              paidDate,
              onCostDetailsClick: trackCostDetailsAnalytics,
              showGraph: showTotalCostOverviewGraph
            }
          ))
        )),
        /* @__PURE__ */ React29.createElement(
          StackItem,
          {
            growFactor: 1,
            css: {
              "@tablet": {
                display: "none"
              },
              "@mobile": {
                display: "none"
              }
            }
          },
          /* @__PURE__ */ React29.createElement(PlanProgressCard, null)
        ),
        hasSupportLink && /* @__PURE__ */ React29.createElement(
          StackItem,
          {
            growFactor: 1,
            css: {
              "@tablet": { display: "none" },
              "@mobile": {
                display: "none"
              }
            }
          },
          /* @__PURE__ */ React29.createElement(SupportCard, null)
        )
      )), !isEmpty(services) && /* @__PURE__ */ React29.createElement(StackLayout10, { spacing: "$half", horizontalAlignment: "stretch" }, /* @__PURE__ */ React29.createElement(
        SectionHeader2,
        {
          headingLevel: "2",
          title: formatMessage({ id: "CLAIMS_SERVICE_DETAILS_HEADING" }),
          subtitle: formatMessage({
            id: "CLAIMS_SERVICE_DETAILS_SUBHEADING"
          })
        }
      ), ServiceDetailsBanner && /* @__PURE__ */ React29.createElement(ServiceDetailsBanner, null), /* @__PURE__ */ React29.createElement(
        ServiceDetails,
        {
          services,
          isPending,
          claimType,
          onCostDetailsClick: trackCostDetailsAnalytics,
          onCostDetailsToggle: trackCostDetailsToggleAction
        }
      )), showTotalCostOverviewAndAdditionalResources && /* @__PURE__ */ React29.createElement(Responsive4, { down: "laptop" }, /* @__PURE__ */ React29.createElement(
        StackLayout10,
        {
          spacing: "$oneAndHalf",
          verticalAlignment: "stretch",
          horizontalAlignment: "stretch",
          orientation: "vertical"
        },
        /* @__PURE__ */ React29.createElement(HeadingText3, { level: "2", size: "lg" }, formatMessage({ id: "CLAIMS_ADDITIONAL_RESOURCES_HEADING" })),
        /* @__PURE__ */ React29.createElement(StackItem, { growFactor: 1 }, /* @__PURE__ */ React29.createElement(PlanProgressCard, null)),
        hasSupportLink && /* @__PURE__ */ React29.createElement(StackItem, { growFactor: 1 }, /* @__PURE__ */ React29.createElement(SupportCard, null))
      )))
    )
  );
}

// src/claims.routes.tsx
var ClaimsRoutes = () => {
  const isInternalClaimDetailsEnabled = useFeatureFlag(
    "shouldShowClaimDetails"
  );
  return /* @__PURE__ */ React30.createElement(Routes, null, /* @__PURE__ */ React30.createElement(Route, { path: "", element: /* @__PURE__ */ React30.createElement(ClaimsSummaryPageContainer, null) }), isInternalClaimDetailsEnabled && /* @__PURE__ */ React30.createElement(Route, { path: ":claimId", element: /* @__PURE__ */ React30.createElement(ClaimDetailsPage, null) }));
};

// src/index.ts
initModule();
export {
  CLAIMS_RECENT_PARAM,
  ClaimsRoutes,
  ClaimsSummaryPageContainer as ClaimsSummaryPage,
  RecentClaimsCardList
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/claims'] = window.leagueSDKsPresent['@leagueplatform/claims'] || [];
    window.leagueSDKsPresent['@leagueplatform/claims'].push('2.22.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/claims'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/claims module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map